webpackJsonp([68530290604204,35783957827783],{

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a,n){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (n), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=n(require,exports,module):a.CountUp=n()}(this,function(a,n,t){var e=function(a,n,t,e,i,r){function o(a){var n,t,e,i,r,o,s=a<0;if(a=Math.abs(a).toFixed(l.decimals),a+="",n=a.split("."),t=n[0],e=n.length>1?l.options.decimal+n[1]:"",l.options.useGrouping){for(i="",r=0,o=t.length;r<o;++r)0!==r&&r%3===0&&(i=l.options.separator+i),i=t[o-r-1]+i;t=i}return l.options.numerals.length&&(t=t.replace(/[0-9]/g,function(a){return l.options.numerals[+a]}),e=e.replace(/[0-9]/g,function(a){return l.options.numerals[+a]})),(s?"-":"")+l.options.prefix+t+e+l.options.suffix}function s(a,n,t,e){return t*(-Math.pow(2,-10*a/e)+1)*1024/1023+n}function u(a){return"number"==typeof a&&!isNaN(a)}var l=this;if(l.version=function(){return"1.9.3"},l.options={useEasing:!0,useGrouping:!0,separator:",",decimal:".",easingFn:s,formattingFn:o,prefix:"",suffix:"",numerals:[]},r&&"object"==typeof r)for(var m in l.options)r.hasOwnProperty(m)&&null!==r[m]&&(l.options[m]=r[m]);""===l.options.separator?l.options.useGrouping=!1:l.options.separator=""+l.options.separator;for(var d=0,c=["webkit","moz","ms","o"],f=0;f<c.length&&!window.requestAnimationFrame;++f)window.requestAnimationFrame=window[c[f]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[c[f]+"CancelAnimationFrame"]||window[c[f]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(a,n){var t=(new Date).getTime(),e=Math.max(0,16-(t-d)),i=window.setTimeout(function(){a(t+e)},e);return d=t+e,i}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)}),l.initialize=function(){return!!l.initialized||(l.error="",l.d="string"==typeof a?document.getElementById(a):a,l.d?(l.startVal=Number(n),l.endVal=Number(t),u(l.startVal)&&u(l.endVal)?(l.decimals=Math.max(0,e||0),l.dec=Math.pow(10,l.decimals),l.duration=1e3*Number(i)||2e3,l.countDown=l.startVal>l.endVal,l.frameVal=l.startVal,l.initialized=!0,!0):(l.error="[CountUp] startVal ("+n+") or endVal ("+t+") is not a number",!1)):(l.error="[CountUp] target is null or undefined",!1))},l.printValue=function(a){var n=l.options.formattingFn(a);"INPUT"===l.d.tagName?this.d.value=n:"text"===l.d.tagName||"tspan"===l.d.tagName?this.d.textContent=n:this.d.innerHTML=n},l.count=function(a){l.startTime||(l.startTime=a),l.timestamp=a;var n=a-l.startTime;l.remaining=l.duration-n,l.options.useEasing?l.countDown?l.frameVal=l.startVal-l.options.easingFn(n,0,l.startVal-l.endVal,l.duration):l.frameVal=l.options.easingFn(n,l.startVal,l.endVal-l.startVal,l.duration):l.countDown?l.frameVal=l.startVal-(l.startVal-l.endVal)*(n/l.duration):l.frameVal=l.startVal+(l.endVal-l.startVal)*(n/l.duration),l.countDown?l.frameVal=l.frameVal<l.endVal?l.endVal:l.frameVal:l.frameVal=l.frameVal>l.endVal?l.endVal:l.frameVal,l.frameVal=Math.round(l.frameVal*l.dec)/l.dec,l.printValue(l.frameVal),n<l.duration?l.rAF=requestAnimationFrame(l.count):l.callback&&l.callback()},l.start=function(a){l.initialize()&&(l.callback=a,l.rAF=requestAnimationFrame(l.count))},l.pauseResume=function(){l.paused?(l.paused=!1,delete l.startTime,l.duration=l.remaining,l.startVal=l.frameVal,requestAnimationFrame(l.count)):(l.paused=!0,cancelAnimationFrame(l.rAF))},l.reset=function(){l.paused=!1,delete l.startTime,l.initialized=!1,l.initialize()&&(cancelAnimationFrame(l.rAF),l.printValue(l.startVal))},l.update=function(a){if(l.initialize()){if(a=Number(a),!u(a))return void(l.error="[CountUp] update() - new endVal is not a number: "+a);l.error="",a!==l.frameVal&&(cancelAnimationFrame(l.rAF),l.paused=!1,delete l.startTime,l.startVal=l.frameVal,l.endVal=a,l.countDown=l.startVal>l.endVal,l.rAF=requestAnimationFrame(l.count))}},l.initialize()&&l.printValue(l.startVal)};return e});

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.startAnimation = exports.formatNumber = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _countup = __webpack_require__(79);
	
	var _countup2 = _interopRequireDefault(_countup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Adapted from the countup.js format number function
	// https://github.com/inorganik/countUp.js/blob/master/countUp.js#L46-L60
	var formatNumber = exports.formatNumber = function formatNumber(start, options) {
	  var neg = start < 0;
	  var num = '' + Math.abs(start).toFixed(options.decimals);
	  var x = num.split('.');
	  var x1 = x[0];
	  var x2 = x.length > 1 ? '' + options.decimal + x[1] : '';
	  var rgx = /(\d+)(\d{3})/;
	
	  if (options.separator) {
	    while (rgx.test(x1)) {
	      x1 = x1.replace(rgx, '$1' + options.separator + '$2');
	    }
	  }
	
	  return '' + (neg ? '-' : '') + (options.prefix || '') + x1 + x2 + (options.suffix || '');
	};
	
	var startAnimation = exports.startAnimation = function startAnimation(component) {
	  if (!(component && component.spanElement)) {
	    throw new Error('You need to pass the CountUp component as an argument!\neg. this.myCountUp.startAnimation(this.myCountUp);');
	  }
	
	  var _component$props = component.props,
	      decimal = _component$props.decimal,
	      decimals = _component$props.decimals,
	      duration = _component$props.duration,
	      easingFn = _component$props.easingFn,
	      end = _component$props.end,
	      formattingFn = _component$props.formattingFn,
	      onComplete = _component$props.onComplete,
	      onStart = _component$props.onStart,
	      prefix = _component$props.prefix,
	      separator = _component$props.separator,
	      start = _component$props.start,
	      suffix = _component$props.suffix,
	      useEasing = _component$props.useEasing;
	
	
	  var countupInstance = new _countup2.default(component.spanElement, start, end, decimals, duration, {
	    decimal: decimal,
	    easingFn: easingFn,
	    formattingFn: formattingFn,
	    separator: separator,
	    prefix: prefix,
	    suffix: suffix,
	    useEasing: useEasing,
	    useGrouping: !!separator
	  });
	
	  if (typeof onStart === 'function') {
	    onStart();
	  }
	
	  countupInstance.start(onComplete);
	};
	
	var CountUp = function (_React$Component) {
	  _inherits(CountUp, _React$Component);
	
	  function CountUp() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CountUp);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountUp.__proto__ || Object.getPrototypeOf(CountUp)).call.apply(_ref, [this].concat(args))), _this), _this.spanElement = null, _this.refSpan = function (span) {
	      _this.spanElement = span;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CountUp, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      startAnimation(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var hasCertainPropsChanged = this.props.duration !== nextProps.duration || this.props.end !== nextProps.end || this.props.start !== nextProps.start;
	
	      return nextProps.redraw || hasCertainPropsChanged;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      startAnimation(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          start = _props.start,
	          decimal = _props.decimal,
	          decimals = _props.decimals,
	          separator = _props.separator,
	          prefix = _props.prefix,
	          suffix = _props.suffix,
	          style = _props.style,
	          formattingFn = _props.formattingFn;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: className, ref: this.refSpan, style: style },
	        typeof formattingFn === 'function' ? formattingFn(start) : formatNumber(start, {
	          decimal: decimal,
	          decimals: decimals,
	          separator: separator,
	          prefix: prefix,
	          suffix: suffix
	        })
	      );
	    }
	  }]);
	
	  return CountUp;
	}(_react2.default.Component);
	
	CountUp.defaultProps = {
	  className: undefined,
	  decimal: '.',
	  decimals: 0,
	  duration: 3,
	  easingFn: null,
	  end: 100,
	  formattingFn: null,
	  onComplete: undefined,
	  onStart: undefined,
	  prefix: '',
	  separator: '',
	  start: 0,
	  suffix: '',
	  redraw: false,
	  style: undefined,
	  useEasing: true
	};
	exports.default = CountUp;

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	     true ? factory(exports) :
	    typeof define === 'function' && define.amd ? define(['exports'], factory) :
	    (factory((global.spaniel = {})));
	}(this, (function (exports) { 'use strict';
	
	    function calculateIsIntersecting(_a) {
	        var intersectionRect = _a.intersectionRect;
	        return intersectionRect.width > 0 || intersectionRect.height > 0;
	    }
	    function getBoundingClientRect(element) {
	        try {
	            return element.getBoundingClientRect();
	        }
	        catch (e) {
	            if (typeof e === 'object' && e !== null && (e.number & 0xffff) === 16389) {
	                return { top: 0, bottom: 0, left: 0, width: 0, height: 0, right: 0, x: 0, y: 0 };
	            }
	            else {
	                throw e;
	            }
	        }
	    }
	
	    /*
	    Copyright 2017 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	
	    /*
	    Copyright 2017 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	    var __extends = (undefined && false) || (function () {
	        var extendStatics = function (d, b) {
	            extendStatics = Object.setPrototypeOf ||
	                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	            return extendStatics(d, b);
	        };
	        return function (d, b) {
	            extendStatics(d, b);
	            function __() { this.constructor = d; }
	            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	        };
	    })();
	    var BaseQueue = /** @class */ (function () {
	        function BaseQueue() {
	            this.items = [];
	        }
	        BaseQueue.prototype.remove = function (identifier) {
	            var len = this.items.length;
	            for (var i = 0; i < len; i++) {
	                if (this.removePredicate(identifier, this.items[i])) {
	                    this.items.splice(i, 1);
	                    i--;
	                    len--;
	                }
	            }
	        };
	        BaseQueue.prototype.clear = function () {
	            this.items = [];
	        };
	        BaseQueue.prototype.push = function (element) {
	            this.items.push(element);
	        };
	        BaseQueue.prototype.isEmpty = function () {
	            return this.items.length === 0;
	        };
	        return BaseQueue;
	    }());
	    var Queue = /** @class */ (function (_super) {
	        __extends(Queue, _super);
	        function Queue() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        Queue.prototype.removePredicate = function (identifier, element) {
	            if (typeof identifier === 'string') {
	                return element.id === identifier;
	            }
	            else {
	                return element.callback === identifier;
	            }
	        };
	        return Queue;
	    }(BaseQueue));
	    var FunctionQueue = /** @class */ (function (_super) {
	        __extends(FunctionQueue, _super);
	        function FunctionQueue() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        FunctionQueue.prototype.removePredicate = function (identifier, element) {
	            return element === identifier;
	        };
	        return FunctionQueue;
	    }(BaseQueue));
	    var DOMQueue = /** @class */ (function (_super) {
	        __extends(DOMQueue, _super);
	        function DOMQueue() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        DOMQueue.prototype.removePredicate = function (identifier, element) {
	            if (typeof identifier === 'string') {
	                return element.id === identifier;
	            }
	            else if (typeof identifier === 'function') {
	                return element.callback === identifier;
	            }
	            else {
	                return element.el === identifier;
	            }
	        };
	        return DOMQueue;
	    }(BaseQueue));
	
	    /*
	    Copyright 2017 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	    var nop = function () { return 0; };
	    var hasDOM = !!(typeof window !== 'undefined' && window && typeof document !== 'undefined' && document);
	    var hasRAF = hasDOM && !!window.requestAnimationFrame;
	    var W = {
	        hasDOM: hasDOM,
	        hasRAF: hasRAF,
	        getScrollTop: nop,
	        getScrollLeft: nop,
	        getHeight: nop,
	        getWidth: nop,
	        rAF: hasRAF
	            ? window.requestAnimationFrame.bind(window)
	            : function (callback) {
	                callback();
	            },
	        meta: {
	            width: 0,
	            height: 0,
	            scrollTop: 0,
	            scrollLeft: 0,
	            x: 0,
	            y: 0,
	            top: 0,
	            left: 0
	        },
	        version: 0,
	        lastVersion: 0,
	        updateMeta: nop,
	        get isDirty() {
	            return W.version !== W.lastVersion;
	        }
	    };
	    function invalidate() {
	        ++W.version;
	    }
	    // Init after DOM Content has loaded
	    function hasDomSetup() {
	        var se = document.scrollingElement != null;
	        W.getScrollTop = se ? function () { return document.scrollingElement.scrollTop; } : function () { return window.scrollY; };
	        W.getScrollLeft = se ? function () { return document.scrollingElement.scrollLeft; } : function () { return window.scrollX; };
	    }
	    if (hasDOM) {
	        // Set the height and width immediately because they will be available at this point
	        W.getHeight = function () { return window.innerHeight; };
	        W.getWidth = function () { return window.innerWidth; };
	        W.updateMeta = function () {
	            W.meta.height = W.getHeight();
	            W.meta.width = W.getWidth();
	            W.meta.scrollLeft = W.getScrollLeft();
	            W.meta.scrollTop = W.getScrollTop();
	            W.lastVersion = W.version;
	        };
	        W.updateMeta();
	        if (document.readyState !== 'loading') {
	            hasDomSetup();
	        }
	        else {
	            document.addEventListener('DOMContentLoaded', hasDomSetup);
	        }
	        window.addEventListener('resize', invalidate, false);
	        window.addEventListener('scroll', invalidate, false);
	    }
	
	    /*
	    Copyright 2017 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	    var Engine = /** @class */ (function () {
	        function Engine() {
	            this.reads = [];
	            this.work = [];
	            this.running = false;
	        }
	        Engine.prototype.scheduleRead = function (callback) {
	            this.reads.unshift(callback);
	            this.run();
	        };
	        Engine.prototype.scheduleWork = function (callback) {
	            this.work.unshift(callback);
	            this.run();
	        };
	        Engine.prototype.run = function () {
	            var _this = this;
	            if (!this.running) {
	                this.running = true;
	                W.rAF(function () {
	                    _this.running = false;
	                    for (var i = 0, rlen = _this.reads.length; i < rlen; i++) {
	                        _this.reads.pop()();
	                    }
	                    for (var i = 0, wlen = _this.work.length; i < wlen; i++) {
	                        _this.work.pop()();
	                    }
	                    if (_this.work.length > 0 || _this.reads.length > 0) {
	                        _this.run();
	                    }
	                });
	            }
	        };
	        return Engine;
	    }());
	    var globalEngine = null;
	    function setGlobalEngine(engine) {
	        if (!!globalEngine) {
	            return false;
	        }
	        globalEngine = engine;
	        return true;
	    }
	    function getGlobalEngine() {
	        return globalEngine || (globalEngine = new Engine());
	    }
	
	    /*
	    Copyright 2017 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	    var __extends$1 = (undefined && false) || (function () {
	        var extendStatics = function (d, b) {
	            extendStatics = Object.setPrototypeOf ||
	                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	            return extendStatics(d, b);
	        };
	        return function (d, b) {
	            extendStatics(d, b);
	            function __() { this.constructor = d; }
	            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	        };
	    })();
	    var TOKEN_SEED = 'xxxx'.replace(/[xy]/g, function (c) {
	        var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
	        return v.toString(16);
	    });
	    var tokenCounter = 0;
	    var Frame = /** @class */ (function () {
	        function Frame(timestamp, scrollTop, scrollLeft, width, height, x, y, top, left) {
	            this.timestamp = timestamp;
	            this.scrollTop = scrollTop;
	            this.scrollLeft = scrollLeft;
	            this.width = width;
	            this.height = height;
	            this.x = x;
	            this.y = y;
	            this.top = top;
	            this.left = left;
	        }
	        Frame.generate = function (root) {
	            if (root === void 0) { root = window; }
	            var rootMeta = this.revalidateRootMeta(root);
	            return new Frame(Date.now(), rootMeta.scrollTop, rootMeta.scrollLeft, rootMeta.width, rootMeta.height, rootMeta.x, rootMeta.y, rootMeta.top, rootMeta.left);
	        };
	        Frame.revalidateRootMeta = function (root) {
	            if (root === void 0) { root = window; }
	            var _clientRect = null;
	            var _rootMeta = {
	                width: 0,
	                height: 0,
	                scrollTop: 0,
	                scrollLeft: 0,
	                x: 0,
	                y: 0,
	                top: 0,
	                left: 0
	            };
	            // if root is dirty update the cached values
	            if (W.isDirty) {
	                W.updateMeta();
	            }
	            if (root === window) {
	                _rootMeta.height = W.meta.height;
	                _rootMeta.width = W.meta.width;
	                _rootMeta.scrollLeft = W.meta.scrollLeft;
	                _rootMeta.scrollTop = W.meta.scrollTop;
	                return _rootMeta;
	            }
	            _clientRect = getBoundingClientRect(root);
	            _rootMeta.scrollTop = root.scrollTop;
	            _rootMeta.scrollLeft = root.scrollLeft;
	            _rootMeta.width = _clientRect.width;
	            _rootMeta.height = _clientRect.height;
	            _rootMeta.x = _clientRect.x;
	            _rootMeta.y = _clientRect.y;
	            _rootMeta.top = _clientRect.top;
	            _rootMeta.left = _clientRect.left;
	            return _rootMeta;
	        };
	        return Frame;
	    }());
	    function generateToken() {
	        return tokenCounter++ + TOKEN_SEED;
	    }
	    var BaseScheduler = /** @class */ (function () {
	        function BaseScheduler(customEngine, root) {
	            if (root === void 0) { root = window; }
	            this.isTicking = false;
	            this.toRemove = [];
	            if (customEngine) {
	                this.engine = customEngine;
	            }
	            else {
	                this.engine = getGlobalEngine();
	            }
	            this.root = root;
	        }
	        BaseScheduler.prototype.tick = function () {
	            if (this.queue.isEmpty()) {
	                this.isTicking = false;
	            }
	            else {
	                if (this.toRemove.length > 0) {
	                    for (var i = 0; i < this.toRemove.length; i++) {
	                        this.queue.remove(this.toRemove[i]);
	                    }
	                    this.toRemove = [];
	                }
	                this.applyQueue(Frame.generate(this.root));
	                this.engine.scheduleRead(this.tick.bind(this));
	            }
	        };
	        BaseScheduler.prototype.scheduleWork = function (callback) {
	            this.engine.scheduleWork(callback);
	        };
	        BaseScheduler.prototype.scheduleRead = function (callback) {
	            this.engine.scheduleRead(callback);
	        };
	        BaseScheduler.prototype.queryElement = function (el, callback) {
	            var _this = this;
	            var clientRect = null;
	            var frame = null;
	            this.engine.scheduleRead(function () {
	                clientRect = getBoundingClientRect(el);
	                frame = Frame.generate(_this.root);
	            });
	            this.engine.scheduleWork(function () {
	                callback(clientRect, frame);
	            });
	        };
	        BaseScheduler.prototype.unwatch = function (id) {
	            this.toRemove.push(id);
	        };
	        BaseScheduler.prototype.unwatchAll = function () {
	            this.queue.clear();
	        };
	        BaseScheduler.prototype.startTicking = function () {
	            if (!this.isTicking) {
	                this.isTicking = true;
	                this.engine.scheduleRead(this.tick.bind(this));
	            }
	        };
	        return BaseScheduler;
	    }());
	    var Scheduler = /** @class */ (function (_super) {
	        __extends$1(Scheduler, _super);
	        function Scheduler() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.queue = new Queue();
	            return _this;
	        }
	        Scheduler.prototype.applyQueue = function (frame) {
	            for (var i = 0; i < this.queue.items.length; i++) {
	                var _a = this.queue.items[i], id = _a.id, callback = _a.callback;
	                callback(frame, id);
	            }
	        };
	        Scheduler.prototype.watch = function (callback) {
	            this.startTicking();
	            var id = generateToken();
	            this.queue.push({
	                callback: callback,
	                id: id
	            });
	            return id;
	        };
	        return Scheduler;
	    }(BaseScheduler));
	    var PredicatedScheduler = /** @class */ (function (_super) {
	        __extends$1(PredicatedScheduler, _super);
	        function PredicatedScheduler(predicate) {
	            var _this = _super.call(this, null, window) || this;
	            _this.predicate = predicate;
	            return _this;
	        }
	        PredicatedScheduler.prototype.applyQueue = function (frame) {
	            if (this.predicate(frame)) {
	                _super.prototype.applyQueue.call(this, frame);
	            }
	        };
	        return PredicatedScheduler;
	    }(Scheduler));
	    var ElementScheduler = /** @class */ (function (_super) {
	        __extends$1(ElementScheduler, _super);
	        function ElementScheduler(customEngine, root, ALLOW_CACHED_SCHEDULER) {
	            if (ALLOW_CACHED_SCHEDULER === void 0) { ALLOW_CACHED_SCHEDULER = true; }
	            var _this = _super.call(this, customEngine, root) || this;
	            _this.lastVersion = W.version;
	            if (ALLOW_CACHED_SCHEDULER === void 0) {
	                ALLOW_CACHED_SCHEDULER = true;
	            }
	            _this.queue = new DOMQueue();
	            _this.ALLOW_CACHED_SCHEDULER = ALLOW_CACHED_SCHEDULER;
	            return _this;
	        }
	        Object.defineProperty(ElementScheduler.prototype, "isDirty", {
	            get: function () {
	                return W.version !== this.lastVersion;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        ElementScheduler.prototype.applyQueue = function (frame) {
	            for (var i = 0; i < this.queue.items.length; i++) {
	                var _a = this.queue.items[i], callback = _a.callback, el = _a.el, id = _a.id, clientRect = _a.clientRect;
	                if (this.isDirty || !clientRect || !this.ALLOW_CACHED_SCHEDULER) {
	                    clientRect = this.queue.items[i].clientRect = getBoundingClientRect(el);
	                }
	                callback(frame, id, clientRect);
	            }
	            this.lastVersion = W.version;
	        };
	        ElementScheduler.prototype.watch = function (el, callback, id) {
	            this.startTicking();
	            id = id || generateToken();
	            var clientRect = null;
	            this.queue.push({
	                el: el,
	                callback: callback,
	                id: id,
	                clientRect: clientRect
	            });
	            return id;
	        };
	        return ElementScheduler;
	    }(BaseScheduler));
	    var globalScheduler = null;
	    function getGlobalScheduler() {
	        return globalScheduler || (globalScheduler = new Scheduler());
	    }
	
	    /*
	    Copyright 2017 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	    var GenericEventRecord = /** @class */ (function () {
	        function GenericEventRecord() {
	            this.queue = new FunctionQueue();
	        }
	        GenericEventRecord.prototype.listen = function (callback) {
	            this.queue.push(callback);
	        };
	        GenericEventRecord.prototype.unlisten = function (callback) {
	            this.queue.remove(callback);
	        };
	        GenericEventRecord.prototype.trigger = function (value) {
	            for (var i = 0; i < this.queue.items.length; i++) {
	                this.queue.items[i](value);
	            }
	        };
	        return GenericEventRecord;
	    }());
	    var RAFEventRecord = /** @class */ (function () {
	        function RAFEventRecord(predicate) {
	            this.scheduler = new PredicatedScheduler(predicate.bind(this));
	        }
	        RAFEventRecord.prototype.trigger = function (value) { };
	        RAFEventRecord.prototype.listen = function (callback) {
	            this.state = Frame.generate();
	            this.scheduler.watch(callback);
	        };
	        RAFEventRecord.prototype.unlisten = function (cb) {
	            this.scheduler.unwatch(cb);
	        };
	        return RAFEventRecord;
	    }());
	    var eventStore = null;
	    function getEventStore() {
	        return (eventStore ||
	            (eventStore = {
	                scroll: new RAFEventRecord(function (frame) {
	                    var _a = this.state, scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft;
	                    this.state = frame;
	                    return scrollTop !== frame.scrollTop || scrollLeft !== frame.scrollLeft;
	                }),
	                resize: new RAFEventRecord(function (frame) {
	                    var _a = this.state, width = _a.width, height = _a.height;
	                    this.state = frame;
	                    return height !== frame.height || width !== frame.width;
	                }),
	                destroy: new GenericEventRecord(),
	                beforeunload: new GenericEventRecord(),
	                hide: new GenericEventRecord(),
	                show: new GenericEventRecord()
	            }));
	    }
	    if (W.hasDOM) {
	        window.addEventListener('beforeunload', function (e) {
	            // First fire internal event to fire any observer callbacks
	            trigger('beforeunload');
	            // Then fire external event to allow flushing of any beacons
	            trigger('destroy');
	        });
	        document.addEventListener('visibilitychange', function onVisibilityChange() {
	            if (document.visibilityState === 'visible') {
	                trigger('show');
	            }
	            else {
	                trigger('hide');
	            }
	        });
	    }
	    function on$$1(eventName, callback) {
	        var evt = getEventStore()[eventName];
	        if (evt) {
	            evt.listen(callback);
	        }
	    }
	    function off$$1(eventName, callback) {
	        if (eventStore) {
	            var evt = eventStore[eventName];
	            if (evt) {
	                evt.unlisten(callback);
	            }
	        }
	    }
	    function trigger(eventName, value) {
	        if (eventStore) {
	            var evt = eventStore[eventName];
	            if (evt) {
	                evt.trigger(value);
	            }
	        }
	    }
	    /**
	     * Schedule a callback to be batched along with other DOM read/query work.
	     * Use to schedule any DOM reads. Doing so will avoid DOM thrashing.
	     */
	    function scheduleWork$$1(callback) {
	        getGlobalScheduler().scheduleWork(callback);
	    }
	    /**
	     * Schedule a callback to be batched along with other DOM write/mutation
	     * work. Use to schedule any DOM changes. Doing so will avoid DOM thrashing.
	     */
	    function scheduleRead$$1(callback) {
	        getGlobalScheduler().scheduleRead(callback);
	    }
	
	    /*
	    Copyright 2017 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	
	    /*
	    Copyright 2017 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	    function marginToRect(margin) {
	        var left = margin.left, right = margin.right, top = margin.top, bottom = margin.bottom;
	        return {
	            left: left,
	            top: top,
	            bottom: bottom,
	            right: right,
	            width: right - left,
	            height: bottom - top
	        };
	    }
	    function rootMarginToDOMMargin(rootMargin) {
	        var c = rootMargin.split(' ').map(function (n) { return parseInt(n, 10); });
	        switch (c.length) {
	            case 2:
	                return { top: c[0], left: c[1], bottom: c[0], right: c[1] };
	            case 3:
	                return { top: c[0], left: c[1], bottom: c[2], right: c[1] };
	            case 4:
	                return { top: c[0], left: c[1], bottom: c[2], right: c[3] };
	            default:
	                return { top: 0, left: 0, bottom: 0, right: 0 };
	        }
	    }
	    var SpanielIntersectionObserver = /** @class */ (function () {
	        function SpanielIntersectionObserver(callback, options) {
	            if (options === void 0) { options = {}; }
	            this.records = {};
	            this.callback = callback;
	            this.id = generateToken();
	            options.threshold = options.threshold || 0;
	            this.rootMarginObj = rootMarginToDOMMargin(options.rootMargin || '0px');
	            this.root = options.root;
	            if (Array.isArray(options.threshold)) {
	                this.thresholds = options.threshold;
	            }
	            else {
	                this.thresholds = [options.threshold];
	            }
	            this.scheduler = new ElementScheduler(null, this.root, options.ALLOW_CACHED_SCHEDULER);
	        }
	        SpanielIntersectionObserver.prototype.observe = function (target) {
	            var _this = this;
	            var trackedTarget = target;
	            var id = (trackedTarget.__spanielId = trackedTarget.__spanielId || generateToken());
	            this.scheduler.watch(target, function (frame, id, clientRect) {
	                _this.onTick(frame, id, clientRect, trackedTarget);
	            }, trackedTarget.__spanielId);
	            return id;
	        };
	        SpanielIntersectionObserver.prototype.onTick = function (frame, id, clientRect, el) {
	            var _this = this;
	            var _a = this.generateEntryEvent(frame, clientRect, el), numSatisfiedThresholds = _a.numSatisfiedThresholds, entry = _a.entry;
	            var record = this.records[id] ||
	                (this.records[id] = {
	                    entry: entry,
	                    numSatisfiedThresholds: 0
	                });
	            if (numSatisfiedThresholds !== record.numSatisfiedThresholds ||
	                entry.isIntersecting !== record.entry.isIntersecting) {
	                record.numSatisfiedThresholds = numSatisfiedThresholds;
	                record.entry = entry;
	                this.scheduler.scheduleWork(function () {
	                    _this.callback([entry]);
	                });
	            }
	        };
	        SpanielIntersectionObserver.prototype.unobserve = function (target) {
	            this.scheduler.unwatch(target.__spanielId);
	            delete this.records[target.__spanielId];
	        };
	        SpanielIntersectionObserver.prototype.disconnect = function () {
	            this.scheduler.unwatchAll();
	            this.records = {};
	        };
	        SpanielIntersectionObserver.prototype.takeRecords = function () {
	            return [];
	        };
	        SpanielIntersectionObserver.prototype.generateEntryEvent = function (frame, clientRect, el) {
	            var count = 0;
	            var entry = generateEntry(frame, clientRect, el, this.rootMarginObj);
	            for (var i = 0; i < this.thresholds.length; i++) {
	                var threshold = this.thresholds[i];
	                if (entry.intersectionRatio >= threshold) {
	                    count++;
	                }
	            }
	            return {
	                numSatisfiedThresholds: count,
	                entry: entry
	            };
	        };
	        return SpanielIntersectionObserver;
	    }());
	    function addRatio(entryInit) {
	        var time = entryInit.time, rootBounds = entryInit.rootBounds, boundingClientRect = entryInit.boundingClientRect, intersectionRect = entryInit.intersectionRect, target = entryInit.target;
	        var boundingArea = boundingClientRect.height * boundingClientRect.width;
	        var intersectionRatio = boundingArea > 0 ? (intersectionRect.width * intersectionRect.height) / boundingArea : 0;
	        return {
	            time: time,
	            rootBounds: rootBounds,
	            boundingClientRect: boundingClientRect,
	            intersectionRect: intersectionRect,
	            target: target,
	            intersectionRatio: intersectionRatio,
	            isIntersecting: calculateIsIntersecting({ intersectionRect: intersectionRect })
	        };
	    }
	    /*
	    export class IntersectionObserverEntry implements IntersectionObserverEntryInit {
	      time: DOMHighResTimeStamp;
	      intersectionRatio: number;
	      rootBounds: DOMRectReadOnly;
	      boundingClientRect: DOMRectReadOnly;
	      intersectionRect: DOMRectReadOnly;
	      target: SpanielTrackedElement;
	
	      constructor(entryInit: IntersectionObserverEntryInit) {
	        this.time = entryInit.time;
	        this.rootBounds = entryInit.rootBounds;
	        this.boundingClientRect = entryInit.boundingClientRect;
	        this.intersectionRect = entryInit.intersectionRect;
	        this.target = entryInit.target;
	
	        let {
	          intersectionRect,
	          boundingClientRect
	        } = entryInit;
	        let boundingArea = boundingClientRect.height * boundingClientRect.width;
	        this.intersectionRatio = boundingArea > 0 ? (intersectionRect.width * intersectionRect.height) / boundingArea : 0;
	      }
	    };
	    */
	    function emptyRect() {
	        return {
	            bottom: 0,
	            height: 0,
	            left: 0,
	            right: 0,
	            top: 0,
	            width: 0,
	            x: 0,
	            y: 0
	        };
	    }
	    function generateEntry(frame, clientRect, el, rootMargin) {
	        if (el.style.display === 'none') {
	            return {
	                boundingClientRect: emptyRect(),
	                intersectionRatio: 0,
	                intersectionRect: emptyRect(),
	                isIntersecting: false,
	                rootBounds: emptyRect(),
	                target: el,
	                time: frame.timestamp
	            };
	        }
	        var bottom = clientRect.bottom, right = clientRect.right;
	        var rootBounds = {
	            left: frame.left + rootMargin.left,
	            top: frame.top + rootMargin.top,
	            bottom: rootMargin.bottom,
	            right: rootMargin.right,
	            width: frame.width - (rootMargin.right + rootMargin.left),
	            height: frame.height - (rootMargin.bottom + rootMargin.top)
	        };
	        var intersectX = Math.max(rootBounds.left, clientRect.left);
	        var intersectY = Math.max(rootBounds.top, clientRect.top);
	        var width = Math.min(rootBounds.left + rootBounds.width, clientRect.right) - intersectX;
	        var height = Math.min(rootBounds.top + rootBounds.height, clientRect.bottom) - intersectY;
	        var intersectionRect = {
	            left: width >= 0 ? intersectX : 0,
	            top: intersectY >= 0 ? intersectY : 0,
	            width: width,
	            height: height,
	            right: right,
	            bottom: bottom
	        };
	        return addRatio({
	            time: frame.timestamp,
	            rootBounds: rootBounds,
	            target: el,
	            boundingClientRect: marginToRect(clientRect),
	            intersectionRect: intersectionRect
	        });
	    }
	
	    /*
	    Copyright 2017 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	     
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	    var emptyRect$1 = { x: 0, y: 0, width: 0, height: 0 };
	    function DOMMarginToRootMargin(d) {
	        return d.top + "px " + d.right + "px " + d.bottom + "px " + d.left + "px";
	    }
	    var SpanielObserver = /** @class */ (function () {
	        function SpanielObserver(callback, options) {
	            if (options === void 0) { options = {}; }
	            var _this = this;
	            this.paused = false;
	            this.queuedEntries = [];
	            this.recordStore = {};
	            this.callback = callback;
	            var root = options.root, rootMargin = options.rootMargin, threshold = options.threshold, ALLOW_CACHED_SCHEDULER = options.ALLOW_CACHED_SCHEDULER;
	            rootMargin = rootMargin || '0px';
	            var convertedRootMargin = typeof rootMargin !== 'string' ? DOMMarginToRootMargin(rootMargin) : rootMargin;
	            this.thresholds = threshold.sort(function (t) { return t.ratio; });
	            var o = {
	                root: root,
	                rootMargin: convertedRootMargin,
	                threshold: this.thresholds.map(function (t) { return t.ratio; }),
	                ALLOW_CACHED_SCHEDULER: ALLOW_CACHED_SCHEDULER
	            };
	            this.observer = new SpanielIntersectionObserver(function (records) { return _this.internalCallback(records); }, o);
	            this.onTabHidden = this._onTabHidden.bind(this);
	            this.onWindowClosed = this._onWindowClosed.bind(this);
	            this.onTabShown = this._onTabShown.bind(this);
	            if (W.hasDOM) {
	                on$$1('beforeunload', this.onWindowClosed);
	                on$$1('hide', this.onTabHidden);
	                on$$1('show', this.onTabShown);
	            }
	        }
	        SpanielObserver.prototype._onWindowClosed = function () {
	            this.onTabHidden();
	        };
	        SpanielObserver.prototype.setAllHidden = function () {
	            var ids = Object.keys(this.recordStore);
	            var time = Date.now();
	            for (var i = 0; i < ids.length; i++) {
	                this.handleRecordExiting(this.recordStore[ids[i]], time);
	            }
	            this.flushQueuedEntries();
	        };
	        SpanielObserver.prototype._onTabHidden = function () {
	            this.paused = true;
	            this.setAllHidden();
	        };
	        SpanielObserver.prototype._onTabShown = function () {
	            this.paused = false;
	            var ids = Object.keys(this.recordStore);
	            var time = Date.now();
	            for (var i = 0; i < ids.length; i++) {
	                var entry = this.recordStore[ids[i]].lastSeenEntry;
	                if (entry) {
	                    var intersectionRatio = entry.intersectionRatio, boundingClientRect = entry.boundingClientRect, rootBounds = entry.rootBounds, intersectionRect = entry.intersectionRect, isIntersecting = entry.isIntersecting, target = entry.target;
	                    this.handleObserverEntry({
	                        intersectionRatio: intersectionRatio,
	                        boundingClientRect: boundingClientRect,
	                        time: time,
	                        isIntersecting: isIntersecting,
	                        rootBounds: rootBounds,
	                        intersectionRect: intersectionRect,
	                        target: target
	                    });
	                }
	            }
	        };
	        SpanielObserver.prototype.internalCallback = function (records) {
	            records.forEach(this.handleObserverEntry.bind(this));
	        };
	        SpanielObserver.prototype.flushQueuedEntries = function () {
	            if (this.queuedEntries.length > 0) {
	                this.callback(this.queuedEntries);
	                this.queuedEntries = [];
	            }
	        };
	        SpanielObserver.prototype.generateSpanielEntry = function (entry, state) {
	            var intersectionRatio = entry.intersectionRatio, time = entry.time, rootBounds = entry.rootBounds, boundingClientRect = entry.boundingClientRect, intersectionRect = entry.intersectionRect, isIntersecting = entry.isIntersecting, target = entry.target;
	            var record = this.recordStore[target.__spanielId];
	            return {
	                intersectionRatio: intersectionRatio,
	                isIntersecting: isIntersecting,
	                time: time,
	                rootBounds: rootBounds,
	                boundingClientRect: boundingClientRect,
	                intersectionRect: intersectionRect,
	                target: target,
	                duration: 0,
	                entering: null,
	                payload: record.payload,
	                label: state.threshold.label
	            };
	        };
	        SpanielObserver.prototype.handleRecordExiting = function (record, time) {
	            var _this = this;
	            if (time === void 0) { time = Date.now(); }
	            record.thresholdStates.forEach(function (state) {
	                _this.handleThresholdExiting({
	                    intersectionRatio: -1,
	                    isIntersecting: false,
	                    time: time,
	                    payload: record.payload,
	                    label: state.threshold.label,
	                    entering: false,
	                    rootBounds: emptyRect$1,
	                    boundingClientRect: emptyRect$1,
	                    intersectionRect: emptyRect$1,
	                    duration: time - state.lastVisible,
	                    target: record.target
	                }, state);
	                state.lastSatisfied = false;
	                state.visible = false;
	                state.lastEntry = null;
	            });
	        };
	        SpanielObserver.prototype.handleThresholdExiting = function (spanielEntry, state) {
	            var time = spanielEntry.time, intersectionRatio = spanielEntry.intersectionRatio;
	            var hasTimeThreshold = !!state.threshold.time;
	            if (state.lastSatisfied && (!hasTimeThreshold || (hasTimeThreshold && state.visible))) {
	                // Make into function
	                spanielEntry.duration = time - state.lastVisible;
	                spanielEntry.entering = false;
	                state.visible = false;
	                this.queuedEntries.push(spanielEntry);
	            }
	            clearTimeout(state.timeoutId);
	        };
	        SpanielObserver.prototype.handleObserverEntry = function (entry) {
	            var _this = this;
	            var time = entry.time;
	            var target = entry.target;
	            var record = this.recordStore[target.__spanielId];
	            if (record) {
	                record.lastSeenEntry = entry;
	                if (!this.paused) {
	                    record.thresholdStates.forEach(function (state) {
	                        // Find the thresholds that were crossed. Since you can have multiple thresholds
	                        // for the same ratio, could be multiple thresholds
	                        var hasTimeThreshold = !!state.threshold.time;
	                        var spanielEntry = _this.generateSpanielEntry(entry, state);
	                        var ratioSatisfied = entry.intersectionRatio >= state.threshold.ratio;
	                        var isIntersecting = calculateIsIntersecting(entry);
	                        if (ratioSatisfied && !state.lastSatisfied && isIntersecting) {
	                            spanielEntry.entering = true;
	                            if (hasTimeThreshold) {
	                                state.lastVisible = time;
	                                var timerId = Number(setTimeout(function () {
	                                    state.visible = true;
	                                    spanielEntry.duration = Date.now() - state.lastVisible;
	                                    _this.callback([spanielEntry]);
	                                }, state.threshold.time));
	                                state.timeoutId = timerId;
	                            }
	                            else {
	                                state.visible = true;
	                                _this.queuedEntries.push(spanielEntry);
	                            }
	                        }
	                        else if (!ratioSatisfied) {
	                            _this.handleThresholdExiting(spanielEntry, state);
	                        }
	                        state.lastEntry = entry;
	                        state.lastSatisfied = ratioSatisfied;
	                    });
	                    this.flushQueuedEntries();
	                }
	            }
	        };
	        SpanielObserver.prototype.disconnect = function () {
	            this.setAllHidden();
	            this.observer.disconnect();
	            this.recordStore = {};
	        };
	        /*
	         * Must be called when the SpanielObserver is done being used.
	         * This will prevent memory leaks.
	         */
	        SpanielObserver.prototype.destroy = function () {
	            this.disconnect();
	            if (W.hasDOM) {
	                off$$1('beforeunload', this.onWindowClosed);
	                off$$1('hide', this.onTabHidden);
	                off$$1('show', this.onTabShown);
	            }
	        };
	        SpanielObserver.prototype.unobserve = function (element) {
	            var _this = this;
	            var record = this.recordStore[element.__spanielId];
	            if (record) {
	                delete this.recordStore[element.__spanielId];
	                this.observer.unobserve(element);
	                scheduleWork$$1(function () {
	                    _this.handleRecordExiting(record);
	                    _this.flushQueuedEntries();
	                });
	            }
	        };
	        SpanielObserver.prototype.observe = function (target, payload) {
	            if (payload === void 0) { payload = null; }
	            var trackedTarget = target;
	            var id = (trackedTarget.__spanielId = trackedTarget.__spanielId || generateToken());
	            this.recordStore[id] = {
	                target: trackedTarget,
	                payload: payload,
	                lastSeenEntry: null,
	                thresholdStates: this.thresholds.map(function (threshold) { return ({
	                    lastSatisfied: false,
	                    lastEntry: null,
	                    threshold: threshold,
	                    visible: false,
	                    lastVisible: null
	                }); })
	            };
	            this.observer.observe(trackedTarget);
	            return id;
	        };
	        return SpanielObserver;
	    }());
	
	    /*
	    Copyright 2016 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	     
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	    function onEntry(entries) {
	        entries.forEach(function (entry) {
	            var label = entry.label, duration = entry.duration, boundingClientRect = entry.boundingClientRect;
	            var opts = {
	                duration: duration,
	                boundingClientRect: boundingClientRect
	            };
	            if (entry.entering) {
	                entry.payload.callback(label, opts);
	            }
	            else if (entry.label === 'impressed') {
	                opts.visibleTime = entry.time - entry.duration;
	                entry.payload.callback('impression-complete', opts);
	            }
	        });
	    }
	    var Watcher = /** @class */ (function () {
	        function Watcher(config) {
	            if (config === void 0) { config = {}; }
	            var time = config.time, ratio = config.ratio, rootMargin = config.rootMargin, root = config.root, ALLOW_CACHED_SCHEDULER = config.ALLOW_CACHED_SCHEDULER;
	            var threshold = [
	                {
	                    label: 'exposed',
	                    time: 0,
	                    ratio: 0
	                }
	            ];
	            if (time) {
	                threshold.push({
	                    label: 'impressed',
	                    time: time,
	                    ratio: ratio || 0
	                });
	            }
	            if (ratio) {
	                threshold.push({
	                    label: 'visible',
	                    time: 0,
	                    ratio: ratio
	                });
	            }
	            this.observer = new SpanielObserver(onEntry, {
	                rootMargin: rootMargin,
	                threshold: threshold,
	                root: root,
	                ALLOW_CACHED_SCHEDULER: ALLOW_CACHED_SCHEDULER
	            });
	        }
	        Watcher.prototype.watch = function (el, callback) {
	            this.observer.observe(el, {
	                callback: callback
	            });
	        };
	        Watcher.prototype.unwatch = function (el) {
	            this.observer.unobserve(el);
	        };
	        Watcher.prototype.disconnect = function () {
	            this.observer.disconnect();
	        };
	        /*
	         * Must be called when the Watcher is done being used.
	         * This will prevent memory leaks.
	         */
	        Watcher.prototype.destroy = function () {
	            this.observer.destroy();
	        };
	        return Watcher;
	    }());
	
	    /*
	    Copyright 2017 LinkedIn Corp. Licensed under the Apache License,
	    Version 2.0 (the "License"); you may not use this file except in
	    compliance with the License. You may obtain a copy of the License
	    at http://www.apache.org/licenses/LICENSE-2.0
	
	    Unless required by applicable law or agreed to in writing, software
	    distributed under the License is distributed on an "AS IS" BASIS,
	    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	    */
	    function queryElement(el, callback) {
	        getGlobalScheduler().queryElement(el, callback);
	    }
	    function elementSatisfiesRatio(el, ratio, callback, rootMargin) {
	        if (ratio === void 0) { ratio = 0; }
	        if (rootMargin === void 0) { rootMargin = { top: 0, bottom: 0, left: 0, right: 0 }; }
	        queryElement(el, function (clientRect, frame) {
	            var entry = generateEntry(frame, clientRect, el, rootMargin);
	            callback(entry.isIntersecting && entry.intersectionRatio >= ratio);
	        });
	    }
	
	    exports.on = on$$1;
	    exports.off = off$$1;
	    exports.scheduleRead = scheduleRead$$1;
	    exports.scheduleWork = scheduleWork$$1;
	    exports.IntersectionObserver = SpanielIntersectionObserver;
	    exports.SpanielObserver = SpanielObserver;
	    exports.setGlobalEngine = setGlobalEngine;
	    exports.getGlobalEngine = getGlobalEngine;
	    exports.__w__ = W;
	    exports.invalidate = invalidate;
	    exports.queryElement = queryElement;
	    exports.elementSatisfiesRatio = elementSatisfiesRatio;
	    exports.Watcher = Watcher;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=spaniel.js.map

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(11);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _webData = __webpack_require__(18);
	
	var _reactAliceCarousel = __webpack_require__(12);
	
	var _reactAliceCarousel2 = _interopRequireDefault(_reactAliceCarousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var responsive = {
	    0: {
	        items: 1
	    },
	    320: {
	        items: 1
	    },
	    550: {
	        items: 2
	    },
	    768: {
	        items: 2
	    },
	    1024: {
	        items: 2
	    },
	    1260: {
	        items: 4
	    },
	    1460: {
	        items: 4
	    },
	    3000: {
	        items: 4
	    }
	};
	
	var ContentSilder = function (_React$Component) {
	    _inherits(ContentSilder, _React$Component);
	
	    function ContentSilder() {
	        _classCallCheck(this, ContentSilder);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    ContentSilder.prototype.galleryItems = function galleryItems() {
	        return _webData.hubblerReviewData.map(function (item, i) {
	            return _react2.default.createElement(
	                'li',
	                { key: i, className: 'slide-item' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'para' },
	                    item.description
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'name' },
	                    '- ',
	                    item.name
	                )
	            );
	        });
	    };
	
	    ContentSilder.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'content-silder' },
	            _react2.default.createElement(
	                'div',
	                { className: 'review-slider' },
	                _react2.default.createElement(_reactAliceCarousel2.default, {
	                    items: this.galleryItems(),
	                    duration: 400,
	                    responsive: responsive,
	                    fadeOutAnimation: true,
	                    mouseDragEnabled: true,
	                    autoPlay: false,
	                    startIndex: 0,
	                    playButtonEnabled: false,
	                    autoPlayInterval: 5000,
	                    autoPlayDirection: 'ltr'
	                })
	            )
	        );
	    };
	
	    return ContentSilder;
	}(_react2.default.Component);
	
	exports.default = ContentSilder;
	module.exports = exports['default'];

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	    _inherits(Footer, _React$Component);
	
	    function Footer() {
	        _classCallCheck(this, Footer);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Footer.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'footer-container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'footer-container-sub' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-info from-our-blog' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'from-our-blog-sub' },
	                        _react2.default.createElement('div', { className: 'title logo' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'footer-menu' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-info product' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'title' },
	                                    'Hubbler'
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/solutions/sales/' },
	                                            'Fit.Sales'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/customerSupport' },
	                                            'Customer Support'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: 'https://help.hubbler.mobi/faq/', target: '_blank' },
	                                            'FAQs'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-info infoformation' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'title' },
	                                    'Company'
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/company/aboutus' },
	                                            'About Us'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/company/leadership-team' },
	                                            'Leadership Team'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/career' },
	                                            'Careers'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/contactUs' },
	                                            'Contact Us'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/privacypolicy' },
	                                            'Privacy Policy'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/termsofuse' },
	                                            'Terms of Use'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-info infoformation' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'title' },
	                                    'Solutions'
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/solutions/employee-engagement' },
	                                            'Employee Engagement'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: '/solutions/community-engagement' },
	                                            'Community Engagement'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-info about-us' },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'trems-and-policy' },
	                        _react2.default.createElement('li', null),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('a', { href: '', className: 'logo twitter' }),
	                            _react2.default.createElement('a', { href: 'https://www.facebook.com/hubbler.mobi/', className: 'logo facebook', target: '_blank' }),
	                            _react2.default.createElement('a', { href: 'https://www.linkedin.com/company/hubbler.mobi/', className: 'logo google', target: '_blank' })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'trems-and-policy-li' },
	                            _react2.default.createElement('div', { className: 'make-india' })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'socail-media' },
	                            _react2.default.createElement('a', { className: 'apple', href: 'https://itunes.apple.com/in/app/hubbler/id1190887110?mt=8', target: '_blank' }),
	                            _react2.default.createElement('a', { className: 'google', href: 'https://play.google.com/store/apps/details?id=mobi.hubbler.app', target: '_blank' })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'make-india-li' },
	                            _react2.default.createElement('div', { className: 'make-india' })
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(11);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _webData = __webpack_require__(18);
	
	var _hubblerStudio = __webpack_require__(154);
	
	var _hubblerStudio2 = _interopRequireDefault(_hubblerStudio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_React$Component) {
	    _inherits(ListItem, _React$Component);
	
	    function ListItem() {
	        _classCallCheck(this, ListItem);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    ListItem.prototype.onClickHandler = function onClickHandler(event) {
	        var curElement = event.target;
	        while (!curElement.classList.contains('list-item')) {
	            curElement = curElement.parentNode;
	        }
	        var itemData = this.props.itemData;
	
	        this.props.onClickHandler(itemData.id, curElement);
	    };
	
	    ListItem.prototype.render = function render() {
	        var _props = this.props,
	            itemData = _props.itemData,
	            activeItem = _props.activeItem;
	
	        return _react2.default.createElement(
	            'li',
	            { id: itemData.id, className: activeItem === itemData.id ? 'active list-item ' + (itemData.activeLabel || '') : 'list-item ' + (itemData.activeLabel || ''), onClick: this.onClickHandler.bind(this) },
	            _react2.default.createElement('div', { className: 'line' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'head' },
	                itemData.title
	            ),
	            itemData.description ? _react2.default.createElement(
	                'div',
	                { className: 'discription' },
	                itemData.description
	            ) : ''
	        );
	    };
	
	    return ListItem;
	}(_react2.default.Component);
	
	var HubblerStudio = function (_React$Component2) {
	    _inherits(HubblerStudio, _React$Component2);
	
	    function HubblerStudio() {
	        _classCallCheck(this, HubblerStudio);
	
	        var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this));
	
	        _this2.state = {
	            activeItem: '1',
	            offsetTop: 0
	        };
	        return _this2;
	    }
	
	    HubblerStudio.prototype.onClickHandler = function onClickHandler(id, curElement) {
	        this.setState({
	            activeItem: id,
	            offsetTop: curElement.offsetTop
	        });
	    };
	
	    HubblerStudio.prototype.render = function render() {
	        var styleChange = this.state.activeItem === '1' || this.state.activeItem === '5' ? true : false;
	        return _react2.default.createElement(
	            'div',
	            { className: 'hubbler-studio' },
	            _react2.default.createElement(
	                'div',
	                { className: 'title', 'data-aos': 'fade-up' },
	                'Powered by ',
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Hubbler Studio'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'details', 'data-aos': 'fade-up' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Convert any business process into an automated workflow with absolutely no coding! You can make Hubbler work for your enterprise the way you want it to.'
	                ),
	                _react2.default.createElement('div', { className: 'sub' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'studio-list-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'studio-list', 'data-aos': 'fade-up', 'data-aos-delay': '150' },
	                    _react2.default.createElement(_List2.default, { items: _webData.hubblerStudioData, listItem: ListItem, activeItem: this.state.activeItem, onClickHandler: this.onClickHandler.bind(this) }),
	                    _react2.default.createElement('div', { className: styleChange ? 'animate-active small' : 'animate-active', style: { top: this.state.offsetTop } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'studio-preview' },
	                    _react2.default.createElement('img', { src: _hubblerStudio2.default, alt: 'hubblerStudio', 'data-aos': 'zoom-out-right' })
	                )
	            )
	        );
	    };
	
	    return HubblerStudio;
	}(_react2.default.Component);
	
	exports.default = HubblerStudio;
	module.exports = exports['default'];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ShowApps = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _List = __webpack_require__(11);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _reactAliceCarousel = __webpack_require__(12);
	
	var _reactAliceCarousel2 = _interopRequireDefault(_reactAliceCarousel);
	
	var _ActiveWrapper = __webpack_require__(17);
	
	var _ActiveWrapper2 = _interopRequireDefault(_ActiveWrapper);
	
	var _attendance = __webpack_require__(112);
	
	var _attendance2 = _interopRequireDefault(_attendance);
	
	var _attendanceApp = __webpack_require__(111);
	
	var _attendanceApp2 = _interopRequireDefault(_attendanceApp);
	
	var _projectsApp = __webpack_require__(139);
	
	var _projectsApp2 = _interopRequireDefault(_projectsApp);
	
	var _iconService = __webpack_require__(128);
	
	var _iconService2 = _interopRequireDefault(_iconService);
	
	var _inventoryApp = __webpack_require__(130);
	
	var _inventoryApp2 = _interopRequireDefault(_inventoryApp);
	
	var _surveyFeedback = __webpack_require__(147);
	
	var _surveyFeedback2 = _interopRequireDefault(_surveyFeedback);
	
	var _deliveryApp = __webpack_require__(123);
	
	var _deliveryApp2 = _interopRequireDefault(_deliveryApp);
	
	var _claims = __webpack_require__(116);
	
	var _claims2 = _interopRequireDefault(_claims);
	
	var _leadTrackerApp = __webpack_require__(132);
	
	var _leadTrackerApp2 = _interopRequireDefault(_leadTrackerApp);
	
	var _securityApp = __webpack_require__(144);
	
	var _securityApp2 = _interopRequireDefault(_securityApp);
	
	var _userMgtSocial = __webpack_require__(149);
	
	var _userMgtSocial2 = _interopRequireDefault(_userMgtSocial);
	
	var _billingApp = __webpack_require__(113);
	
	var _billingApp2 = _interopRequireDefault(_billingApp);
	
	var _locationMgt = __webpack_require__(137);
	
	var _locationMgt2 = _interopRequireDefault(_locationMgt);
	
	var _referalApp = __webpack_require__(143);
	
	var _referalApp2 = _interopRequireDefault(_referalApp);
	
	var _learningApp = __webpack_require__(134);
	
	var _learningApp2 = _interopRequireDefault(_learningApp);
	
	var _survey = __webpack_require__(148);
	
	var _survey2 = _interopRequireDefault(_survey);
	
	var _learning = __webpack_require__(135);
	
	var _learning2 = _interopRequireDefault(_learning);
	
	var _leadTracker = __webpack_require__(133);
	
	var _leadTracker2 = _interopRequireDefault(_leadTracker);
	
	var _social = __webpack_require__(146);
	
	var _social2 = _interopRequireDefault(_social);
	
	var _services = __webpack_require__(145);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _projectsNTasks = __webpack_require__(140);
	
	var _projectsNTasks2 = _interopRequireDefault(_projectsNTasks);
	
	var _locationMgt3 = __webpack_require__(136);
	
	var _locationMgt4 = _interopRequireDefault(_locationMgt3);
	
	var _delivery = __webpack_require__(124);
	
	var _delivery2 = _interopRequireDefault(_delivery);
	
	var _orderManagement = __webpack_require__(138);
	
	var _orderManagement2 = _interopRequireDefault(_orderManagement);
	
	var _customerIconApp = __webpack_require__(121);
	
	var _customerIconApp2 = _interopRequireDefault(_customerIconApp);
	
	var _vendorManagement = __webpack_require__(150);
	
	var _vendorManagement2 = _interopRequireDefault(_vendorManagement);
	
	var _inventoryManagement = __webpack_require__(131);
	
	var _inventoryManagement2 = _interopRequireDefault(_inventoryManagement);
	
	var _billing = __webpack_require__(114);
	
	var _billing2 = _interopRequireDefault(_billing);
	
	var _collection = __webpack_require__(118);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _purchaseRequestApp = __webpack_require__(141);
	
	var _purchaseRequestApp2 = _interopRequireDefault(_purchaseRequestApp);
	
	var _purchaseRequisition = __webpack_require__(142);
	
	var _purchaseRequisition2 = _interopRequireDefault(_purchaseRequisition);
	
	var _claimsApp = __webpack_require__(115);
	
	var _claimsApp2 = _interopRequireDefault(_claimsApp);
	
	var _collectionIconApp = __webpack_require__(117);
	
	var _collectionIconApp2 = _interopRequireDefault(_collectionIconApp);
	
	var _customerManagement = __webpack_require__(122);
	
	var _customerManagement2 = _interopRequireDefault(_customerManagement);
	
	var _incentives = __webpack_require__(129);
	
	var _incentives2 = _interopRequireDefault(_incentives);
	
	var _iconLeaderboard = __webpack_require__(127);
	
	var _iconLeaderboard2 = _interopRequireDefault(_iconLeaderboard);
	
	var _distributorMgtIconApp = __webpack_require__(125);
	
	var _distributorMgtIconApp2 = _interopRequireDefault(_distributorMgtIconApp);
	
	var _distributorMgt = __webpack_require__(126);
	
	var _distributorMgt2 = _interopRequireDefault(_distributorMgt);
	
	var _crmIcon = __webpack_require__(119);
	
	var _crmIcon2 = _interopRequireDefault(_crmIcon);
	
	var _AssetMgtIcon = __webpack_require__(108);
	
	var _AssetMgtIcon2 = _interopRequireDefault(_AssetMgtIcon);
	
	var _customAppIcon2x = __webpack_require__(120);
	
	var _customAppIcon2x2 = _interopRequireDefault(_customAppIcon2x);
	
	var _AssetMgt = __webpack_require__(109);
	
	var _AssetMgt2 = _interopRequireDefault(_AssetMgt);
	
	var _Referrals = __webpack_require__(110);
	
	var _Referrals2 = _interopRequireDefault(_Referrals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var appMobileImages = {
	    attendance: _attendance2.default,
	    claims: _claims2.default,
	    survey: _survey2.default,
	    learning: _learning2.default,
	    leadTracker: _leadTracker2.default,
	    social: _social2.default,
	    serviceTicketing: _services2.default,
	    projectAndtask: _projectsNTasks2.default,
	    location: _locationMgt4.default,
	    delivery: _delivery2.default,
	    orderMngt: _orderManagement2.default,
	    customerIcon: _vendorManagement2.default,
	    inventory: _inventoryManagement2.default,
	    billing: _billing2.default,
	    collection: _collection2.default,
	    purchaseRequest: _purchaseRequisition2.default,
	    customerManagement: _customerManagement2.default,
	    incentives: _incentives2.default,
	    distributorMgt: _distributorMgt2.default,
	    AssetMgt: _AssetMgt2.default,
	    crm: _customerManagement2.default,
	    referal: _Referrals2.default
	};
	
	var appIcons = {
	    attendance: _attendanceApp2.default,
	    projectAndtask: _projectsApp2.default,
	    serviceTicketing: _iconService2.default,
	    inventory: _inventoryApp2.default,
	    survey: _surveyFeedback2.default,
	    delivery: _deliveryApp2.default,
	    leadTracker: _leadTrackerApp2.default,
	    security: _securityApp2.default,
	    social: _userMgtSocial2.default,
	    billing: _billingApp2.default,
	    location: _locationMgt2.default,
	    referal: _referalApp2.default,
	    learning: _learningApp2.default,
	    orderMngt: _deliveryApp2.default,
	    customerIcon: _customerIconApp2.default,
	    purchaseRequest: _purchaseRequestApp2.default,
	    claims: _claimsApp2.default,
	    collection: _collectionIconApp2.default,
	    customerManagement: _customerIconApp2.default,
	    incentives: _iconLeaderboard2.default,
	    distributorMgt: _distributorMgtIconApp2.default,
	    crm: _customerIconApp2.default,
	    AssetMgt: _AssetMgtIcon2.default,
	    buildYourOwn: _customAppIcon2x2.default
	    /*
	        customerManagement:customerManagementApp
	    */
	};
	
	var listingUrl = {
	    hr: '/solutions/employee-engagement',
	    sales: '/solutions/sales/'
	};
	
	var responsive = {
	    0: {
	        items: 1
	    },
	    320: {
	        items: 1
	    },
	    650: {
	        items: 2
	    },
	    767: {
	        items: 3
	    },
	    1260: {
	        items: 4
	    },
	    1460: {
	        items: 5
	    }
	};
	
	var AppListItem = function (_React$Component) {
	    _inherits(AppListItem, _React$Component);
	
	    function AppListItem() {
	        _classCallCheck(this, AppListItem);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    AppListItem.prototype.onClickContent = function onClickContent() {
	        var itemData = this.props.itemData;
	
	        if (!itemData.noClick) {
	            this.props.onClickApps(itemData);
	        }
	    };
	
	    AppListItem.prototype.render = function render() {
	        var _props = this.props,
	            itemData = _props.itemData,
	            previewImg = _props.previewImg;
	
	        return _react2.default.createElement(
	            'li',
	            { className: previewImg === itemData.image ? 'app-li ' + itemData.app + ' active ' + itemData.image : 'app-li ' + itemData.app + ' ' + itemData.image, key: itemData.id, id: itemData.id, onClick: this.onClickContent.bind(this)
	            },
	            _react2.default.createElement(
	                _ActiveWrapper2.default,
	                { active: itemData.id !== 'explore' },
	                _react2.default.createElement(
	                    'div',
	                    { 'data-aos': 'fade-left', 'data-aos-offset': '10', className: 'app-list-cls' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'image' },
	                        _react2.default.createElement('img', { src: appIcons[itemData.image] })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        itemData.title
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'discription' },
	                        itemData.description
	                    )
	                )
	            )
	        );
	    };
	
	    return AppListItem;
	}(_react2.default.Component);
	
	var ShowApps = exports.ShowApps = function (_React$Component2) {
	    _inherits(ShowApps, _React$Component2);
	
	    function ShowApps() {
	        _classCallCheck(this, ShowApps);
	
	        var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this));
	
	        _this2.state = {
	            activeId: 'hr',
	            listWidth: 70,
	            marginLeft: 0,
	            previewImg: 'leadTracker'
	        };
	        return _this2;
	    }
	
	    ShowApps.prototype.onClickApps = function onClickApps(item) {
	        this.setState({
	            previewImg: item.image
	        });
	    };
	
	    ShowApps.prototype.menuClickHandler = function menuClickHandler(id, event) {
	        var offSet = event.target.getBoundingClientRect();
	        var _props$appsData = this.props.appsData,
	            appsData = _props$appsData === undefined ? [] : _props$appsData;
	
	        var selectedList = appsData.filter(function (item) {
	            return item.app === id;
	        });
	        this.setState({
	            activeId: id,
	            listWidth: offSet.width,
	            marginLeft: event.target.offsetLeft,
	            previewImg: selectedList[0].image
	        });
	    };
	
	    ShowApps.prototype.onSlideChanged = function onSlideChanged(selectedList, event) {
	        var activeApp = selectedList[event.item];
	        this.previewImg.src = appMobileImages[activeApp.image];
	    };
	
	    ShowApps.prototype.galleryItems = function galleryItems(selectedList) {
	        return selectedList.map(function (item, i) {
	            return _react2.default.createElement(AppListItem, { id: item.id, key: item.id, itemData: _extends({}, item, { noClick: true }), onClickApps: this.onClickApps.bind(this), previewImg: this.state.previewImg });
	        }, this);
	    };
	
	    ShowApps.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props$appsData2 = this.props.appsData,
	            appsData = _props$appsData2 === undefined ? [] : _props$appsData2;
	
	        var selectedList = appsData.filter(function (item) {
	            return item.app === _this3.state.activeId;
	        });
	        return _react2.default.createElement(
	            'div',
	            { className: 'show-apps-container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'menu-list', 'data-aos': 'fade-up' },
	                _react2.default.createElement('div', { className: 'empty-div' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'list-ul' },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            { onClick: this.menuClickHandler.bind(this, 'hr'), className: this.state.activeId === 'hr' ? 'active' : '' },
	                            'HR'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { onClick: this.menuClickHandler.bind(this, 'sales'), className: this.state.activeId === 'sales' ? 'active' : '' },
	                            'Sales'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { onClick: this.menuClickHandler.bind(this, 'service'), className: this.state.activeId === 'service' ? 'active' : '' },
	                            'Services'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { onClick: this.menuClickHandler.bind(this, 'operations'), className: this.state.activeId === 'operations' ? 'active' : '' },
	                            'Operations'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { onClick: this.menuClickHandler.bind(this, 'finance'), className: this.state.activeId === 'finance' ? 'active' : '' },
	                            'Finance'
	                        ),
	                        _react2.default.createElement('hr', { style: { width: this.state.listWidth, left: this.state.marginLeft } })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'show-apps-list-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'preview-apps' },
	                    _react2.default.createElement('img', { src: appMobileImages[this.state.previewImg] || '', className: 'pre-img', ref: function ref(img) {
	                            return _this3.previewImg = img;
	                        } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'show-app-list-mobile' },
	                    _react2.default.createElement(_reactAliceCarousel2.default, {
	                        items: this.galleryItems(selectedList),
	                        duration: 400,
	                        responsive: responsive,
	                        fadeOutAnimation: true,
	                        mouseDragEnabled: false,
	                        autoPlay: false,
	                        startIndex: this.state.startIndex,
	                        playButtonEnabled: false,
	                        autoPlayInterval: 5000,
	                        autoPlayDirection: 'ltr',
	                        onSlideChanged: this.onSlideChanged.bind(this, selectedList)
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'show-app-list' },
	                    _react2.default.createElement(_List2.default, { items: [].concat(selectedList, [{ id: 'explore', title: 'Explore All', app: 'explore', noClick: true }]), listItem: AppListItem, className: 'apps-ul-list', onClickApps: this.onClickApps.bind(this), previewImg: this.state.previewImg }),
	                    this.state.activeId === 'hr' || this.state.activeId === 'sales' ? _react2.default.createElement(
	                        'div',
	                        { className: 'explore-all' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'bt-blue bt' },
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                { to: listingUrl[this.state.activeId] },
	                                'Explore All'
	                            )
	                        )
	                    ) : null
	                )
	            )
	        );
	    };
	
	    return ShowApps;
	}(_react2.default.Component);

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SideScroll = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _List = __webpack_require__(11);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _reactAliceCarousel = __webpack_require__(12);
	
	var _reactAliceCarousel2 = _interopRequireDefault(_reactAliceCarousel);
	
	var _qusBg = __webpack_require__(155);
	
	var _qusBg2 = _interopRequireDefault(_qusBg);
	
	var _qusBg3 = __webpack_require__(157);
	
	var _qusBg4 = _interopRequireDefault(_qusBg3);
	
	var _qusBg5 = __webpack_require__(160);
	
	var _qusBg6 = _interopRequireDefault(_qusBg5);
	
	var _qusBg7 = __webpack_require__(158);
	
	var _qusBg8 = _interopRequireDefault(_qusBg7);
	
	var _qusBg9 = __webpack_require__(156);
	
	var _qusBg10 = _interopRequireDefault(_qusBg9);
	
	var _qusBg11 = __webpack_require__(159);
	
	var _qusBg12 = _interopRequireDefault(_qusBg11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bgImages = {
	    img1: _qusBg2.default,
	    img2: _qusBg4.default,
	    img3: _qusBg6.default,
	    img4: _qusBg8.default,
	    img5: _qusBg10.default,
	    img6: _qusBg12.default
	};
	
	var responsive = {
	    0: {
	        items: 1
	    },
	    320: {
	        items: 1
	    },
	    650: {
	        items: 2
	    },
	    767: {
	        items: 3
	    },
	    1260: {
	        items: 4
	    },
	    1460: {
	        items: 5
	    }
	};
	var responsivePopup = {
	    0: {
	        items: 1
	    }
	};
	var imageList = [{
	    id: '1',
	    name: 'project and task',
	    image: ''
	}, {
	    id: '2',
	    name: 'inventory',
	    image: ''
	}, {
	    id: '3',
	    name: 'mis',
	    image: ''
	}];
	
	var QuestionItemView = function (_React$Component) {
	    _inherits(QuestionItemView, _React$Component);
	
	    function QuestionItemView() {
	        _classCallCheck(this, QuestionItemView);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	        _this.state = {
	            activeItem: '1'
	        };
	        return _this;
	    }
	
	    QuestionItemView.prototype.onClickhandler = function onClickhandler(item) {
	        this.setState({
	            activeItem: item.id
	        });
	    };
	
	    QuestionItemView.prototype.popupCloseHandler = function popupCloseHandler(e) {
	        this.props.closePopup();
	    };
	
	    QuestionItemView.prototype.render = function render() {
	        var _this2 = this;
	
	        var item = this.props.item;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'question-container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'preview' },
	                _react2.default.createElement('div', { className: 'preview-content' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'image-list' },
	                    imageList.map(function (item) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: item.id, className: item.id === _this2.state.activeItem ? 'img-cls active' : 'img-cls', onClick: _this2.onClickhandler.bind(_this2, item) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'logo' },
	                                'img'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'name' },
	                                item.name
	                            )
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'details' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'close', onClick: this.popupCloseHandler.bind(this) },
	                    '\xD7'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'ans' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        'Engineering ',
	                        item.id
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'qus' },
	                        'How do I store and manage all my assets from a single place?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Cras justo odio, dapibus ac facilisis in, egestas eget quam. Cras mattis consectetur purus sit amet fermentum. Maecenas faucibus mollis interduma.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'use' },
	                        'Using all three apps'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Cras justo odio, dapibus ac facilisis in, egestas eget quam. Cras mattis consectetur purus sit amet fermentum. Maecenas faucibus mollis interdum.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'demo-btn' },
	                        'Request a Demo'
	                    )
	                )
	            )
	        );
	    };
	
	    return QuestionItemView;
	}(_react2.default.Component);
	
	var PopupComponent = function (_React$Component2) {
	    _inherits(PopupComponent, _React$Component2);
	
	    function PopupComponent() {
	        _classCallCheck(this, PopupComponent);
	
	        var _this3 = _possibleConstructorReturn(this, _React$Component2.call(this));
	
	        _this3.state = {
	            activeClass: false
	        };
	        return _this3;
	    }
	
	    PopupComponent.prototype.galleryItems = function galleryItems() {
	        var _props$data = this.props.data,
	            data = _props$data === undefined ? [] : _props$data;
	
	        return data.map(function (item, i) {
	            return _react2.default.createElement(QuestionItemView, { closePopup: this.props.closePopup, id: item.id, key: item.id, onClick: this.onClickContent, item: item });
	        }, this);
	    };
	
	    PopupComponent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'popup-container' },
	            _react2.default.createElement('div', { id: 'popup1', className: this.props.closeAnimation ? 'close-animation overlay' : 'overlay' }),
	            _react2.default.createElement(
	                'div',
	                { className: this.props.closeAnimation ? 'close-animation popup' : 'popup' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content question-popup' },
	                    _react2.default.createElement(_reactAliceCarousel2.default, {
	                        items: this.galleryItems(),
	                        duration: 400,
	                        fadeOutAnimation: true,
	                        mouseDragEnabled: false,
	                        autoPlay: false,
	                        startIndex: 0,
	                        playButtonEnabled: false,
	                        autoPlayInterval: 1000,
	                        autoPlayDirection: 'ltr'
	                    }),
	                    '                    '
	                )
	            )
	        );
	    };
	
	    return PopupComponent;
	}(_react2.default.Component);
	
	var ListItem = function (_React$Component3) {
	    _inherits(ListItem, _React$Component3);
	
	    function ListItem() {
	        _classCallCheck(this, ListItem);
	
	        return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
	    }
	
	    ListItem.prototype.onClickHandler = function onClickHandler() {
	        this.props.onClickContent();
	    };
	
	    ListItem.prototype.render = function render() {
	        var itemData = this.props.itemData;
	        return _react2.default.createElement(
	            'li',
	            { key: itemData.id, onClick: this.onClickHandler.bind(this), className: itemData.className, ref: itemData.tag || '' },
	            itemData.description
	        );
	    };
	
	    return ListItem;
	}(_react2.default.Component);
	
	var SideScroll = exports.SideScroll = function (_React$Component4) {
	    _inherits(SideScroll, _React$Component4);
	
	    function SideScroll() {
	        _classCallCheck(this, SideScroll);
	
	        var _this5 = _possibleConstructorReturn(this, _React$Component4.call(this));
	
	        _this5.state = {
	            activeItem: 'leadership',
	            activeClass: 'leadership',
	            autoPlay: true,
	            showPopup: false,
	            startIndex: 0,
	            navWidth: 138,
	            navHeight: 34,
	            left: 0,
	            closeAnimation: false
	        };
	        _this5.onClickContent = _this5.onClickContent.bind(_this5);
	        return _this5;
	    }
	
	    SideScroll.prototype.onClickContent = function onClickContent(event) {
	        event.preventDefault();
	        /*   document.body.classList.remove('close-open-cls');
	           document.body.classList.add('popup-open-cls');
	           this.setState({
	               autoPlay:false,
	               showPopup:true,
	               closeAnimation:false
	           })*/
	    };
	
	    SideScroll.prototype.domHandler = function domHandler() {
	        var elements = document.getElementsByClassName('menu active');
	        if (elements) {
	            elements[0].classList.remove('active');
	        }
	    };
	
	    SideScroll.prototype.galleryItems = function galleryItems() {
	        var _props$data2 = this.props.data,
	            data = _props$data2 === undefined ? [] : _props$data2;
	
	        return data.map(function (item, i) {
	            return _react2.default.createElement(
	                'li',
	                { ref: item.tag, className: item.className, id: item.id, key: item.id, style: { backgroundImage: 'url(' + bgImages[item.bgImage] + ')' }, onClick: this.onClickContent },
	                item.description
	            );
	        }, this);
	    };
	
	    SideScroll.prototype.onSlideChange = function onSlideChange(event) {};
	
	    SideScroll.prototype.onSlideChanged = function onSlideChanged(event) {
	        var _props = this.props,
	            data = _props.data,
	            width = _props.width;
	
	        var activeItem = '';
	        if (screen.width < 1025) {
	            activeItem = data[event.item];
	        } else {
	            activeItem = data[event.item + 1];
	        }
	        if (event.item === data.length - 1) {
	            activeItem = data[1];
	        }
	        var animationElements = document.getElementById(activeItem.className);
	        this.animationHandler(activeItem.className, animationElements, activeItem);
	    };
	
	    SideScroll.prototype.animationHandler = function animationHandler(activeClassName, offset, activeItem) {
	        this.domHandler();
	        document.getElementById(activeClassName).classList.add("active");
	        var animationElements = document.getElementById(activeClassName);
	        var animateNav = document.getElementById('animate-nav');
	        animateNav.style.left = offset.offsetLeft + 'px';
	        animateNav.style.width = offset.clientWidth + 'px';
	        animateNav.style.backgroundImage = 'url(' + bgImages[activeItem.bgImage] + ')';
	        this.slideContent.id = activeClassName;
	    };
	
	    SideScroll.prototype.closePopup = function closePopup() {
	        var _this6 = this;
	
	        this.setState({
	            closeAnimation: true
	        });
	        setTimeout(function () {
	            document.body.classList.remove('popup-open-cls');
	            document.body.classList.add('close-open-cls');
	            _this6.setState({
	                showPopup: false,
	                autoPlay: true
	            });
	        }, 650);
	    };
	
	    SideScroll.prototype.onMenuSelection = function onMenuSelection(item, event) {
	        var data = this.props.data;
	
	        var activeIndex = data.find(function (field) {
	            return field.className === item;
	        });
	        this.setState({
	            startIndex: Number(activeIndex.id)
	        });
	        this.animationHandler(item, event.target, activeIndex);
	    };
	
	    SideScroll.prototype.render = function render() {
	        var _this7 = this;
	
	        var data = this.props.data;
	
	        console.log(this.state.activeItem);
	        return _react2.default.createElement(
	            'div',
	            { className: 'side-scroll-container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'nav-details', 'data-aos': 'fade-up' },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'menuList', ref: function ref(menu) {
	                            return _this7.menuList = menu;
	                        } },
	                    _react2.default.createElement(
	                        'li',
	                        { className: this.state.activeClass === 'leadership' ? 'active menu' : 'menu', id: 'leadership', onClick: this.onMenuSelection.bind(this, 'leadership') },
	                        'Leadership'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: this.state.activeClass === 'sales' ? 'active menu' : 'menu', id: 'sales', onClick: this.onMenuSelection.bind(this, 'sales') },
	                        'Sales'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: this.state.activeClass === 'hr' ? 'active menu' : 'menu', id: 'hr', onClick: this.onMenuSelection.bind(this, 'hr') },
	                        'HR'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: this.state.activeClass === 'operations' ? 'active menu' : 'menu', id: 'operations', onClick: this.onMenuSelection.bind(this, 'operations') },
	                        'Business Operations'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: this.state.activeClass === 'finance' ? 'active menu' : 'menu', id: 'finance', onClick: this.onMenuSelection.bind(this, 'finance') },
	                        'Finance'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: this.state.activeClass === 'technology' ? 'active menu' : 'menu', id: 'technology', onClick: this.onMenuSelection.bind(this, 'technology') },
	                        'Technology'
	                    ),
	                    _react2.default.createElement('div', { className: 'menu-animation', id: 'animate-nav', style: { width: this.state.navWidth, height: this.state.navHeight, left: this.state.left } })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'silder-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'silder-content-sub', 'data-aos': 'fade-up', ref: function ref(slide) {
	                            return _this7.slideContent = slide;
	                        }, id: 'leadership' },
	                    _react2.default.createElement(_reactAliceCarousel2.default, {
	                        items: this.galleryItems(),
	                        duration: 400,
	                        responsive: responsive,
	                        fadeOutAnimation: true,
	                        mouseDragEnabled: false,
	                        autoPlay: true,
	                        startIndex: this.state.startIndex,
	                        playButtonEnabled: false,
	                        autoPlayInterval: 5000,
	                        autoPlayDirection: 'ltr',
	                        onSlideChange: this.onSlideChange.bind(this),
	                        onSlideChanged: this.onSlideChanged.bind(this)
	                    })
	                )
	            )
	        );
	    };
	
	    return SideScroll;
	}(_react2.default.Component);

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(11);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _reactAliceCarousel = __webpack_require__(12);
	
	var _reactAliceCarousel2 = _interopRequireDefault(_reactAliceCarousel);
	
	var _group = __webpack_require__(162);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _golive34po = __webpack_require__(161);
	
	var _golive34po2 = _interopRequireDefault(_golive34po);
	
	var _intergrate2x = __webpack_require__(163);
	
	var _intergrate2x2 = _interopRequireDefault(_intergrate2x);
	
	var _problems2x = __webpack_require__(164);
	
	var _problems2x2 = _interopRequireDefault(_problems2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var solutionData = [{
	    id: '1',
	    title: 'Tell us about your business process',
	    step: 'step 1',
	    discription: "We'll understand your process and design a workflow that's perfect for it.",
	    image: _problems2x2.default
	}, {
	    id: '2',
	    title: 'Make it what you want',
	    step: 'step 2',
	    discription: "Choose features, add rules, customize interfaces & automate tasks with ease.",
	    image: _group2.default
	}, {
	    id: '3',
	    title: 'Go live the next day',
	    step: 'step 3',
	    discription: "We'll deliver a powerful business app that works across iOS, Android and Web in record time.",
	    image: _golive34po2.default
	}];
	
	var ListItem = function (_React$Component) {
	    _inherits(ListItem, _React$Component);
	
	    function ListItem() {
	        _classCallCheck(this, ListItem);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    ListItem.prototype.onClickHandler = function onClickHandler(event) {
	        var curElement = event.target;
	        while (!curElement.classList.contains('list-item')) {
	            curElement = curElement.parentNode;
	        }
	        var itemData = this.props.itemData;
	
	        this.props.onClickHandler(itemData.id, curElement, itemData.image);
	    };
	
	    ListItem.prototype.render = function render() {
	        var _props = this.props,
	            itemData = _props.itemData,
	            activeItem = _props.activeItem,
	            step = _props.step;
	
	        return _react2.default.createElement(
	            'li',
	            { id: itemData.id, className: activeItem === itemData.id ? 'active list-item ' + itemData.id : 'list-item ' + itemData.id, onClick: this.onClickHandler.bind(this) },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'step' },
	                    itemData.step
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    itemData.title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'discription' },
	                    itemData.discription
	                )
	            )
	        );
	    };
	
	    return ListItem;
	}(_react2.default.Component);
	
	var Solutions = function (_React$Component2) {
	    _inherits(Solutions, _React$Component2);
	
	    function Solutions() {
	        _classCallCheck(this, Solutions);
	
	        var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this));
	
	        _this2.state = {
	            activeItem: '1',
	            offsetTop: 124,
	            previewImage: _problems2x2.default
	        };
	        return _this2;
	    }
	
	    Solutions.prototype.onClickHandler = function onClickHandler(id, curElement, previewImage) {
	        this.setState({
	            activeItem: id,
	            offsetTop: curElement.offsetTop,
	            previewImage: previewImage
	        });
	    };
	
	    Solutions.prototype.galleryItems = function galleryItems() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            'test'
	        );
	    };
	
	    Solutions.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'solutions-cls' },
	            _react2.default.createElement(
	                'div',
	                { className: 'solution-list', 'data-aos': 'fade-up', 'data-aos-delay': '250' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-hub' },
	                    'Automate your business process in 3 simple steps'
	                ),
	                _react2.default.createElement(_List2.default, { items: solutionData, listItem: ListItem, activeItem: this.state.activeItem, onClickHandler: this.onClickHandler.bind(this) }),
	                _react2.default.createElement('div', { className: 'animation-active', style: { top: this.state.offsetTop } })
	            ),
	            _react2.default.createElement('div', { className: 'solution-preview web img-' + this.state.activeItem, style: { backgroundImage: 'url(' + this.state.previewImage + ')' } }),
	            _react2.default.createElement(
	                'div',
	                { className: 'dis-mobile' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-hub mobile' },
	                    'How Hubbler digitizes your workflow'
	                ),
	                _react2.default.createElement(
	                    _reactAliceCarousel2.default,
	                    { autoPlay: false, autoPlayInterval: 5000, duration: 500 },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dash' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'step' },
	                                'Step 1'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                'Tell us about your business process'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'discription' },
	                                'We\'ll understand your process and design a workflow that\'s perfect for you.'
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'solution-preview', 'data-aos': 'fade-up', style: { backgroundImage: 'url(' + _problems2x2.default + ')' } })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dash' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'step' },
	                                'step 2'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                'Choose your features like toppings for a sub'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'discription' },
	                                'Choose your features, modify the interface, set the business rules and approval workflows  - and we\u2019ll get it done for you.'
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'solution-preview', 'data-aos': 'fade-up', style: { backgroundImage: 'url(' + _group2.default + ')' } })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dash' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'step' },
	                                'step 3'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                'Go live the next day'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'discription' },
	                                'We\'ll deliver a powerful, fully-automated business app for your team across iOS, Android and Web in record time.'
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'solution-preview', 'data-aos': 'fade-up', style: { backgroundImage: 'url(' + _golive34po2.default + ')' } })
	                    )
	                )
	            )
	        );
	    };
	
	    return Solutions;
	}(_react2.default.Component);
	
	exports.default = Solutions;
	module.exports = exports['default'];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Typing = function (_React$Component) {
	    _inherits(Typing, _React$Component);
	
	    function Typing(props) {
	        _classCallCheck(this, Typing);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            toRotate: props.dataType || [],
	            loopNum: 0,
	            period: parseInt(props.dataPeriod, 10) || 2000,
	            txt: '',
	            isMounted: false
	        };
	        return _this;
	    }
	
	    Typing.prototype.TextType = function TextType() {
	        this.tick();
	        this.isDeleting = false;
	    };
	
	    Typing.prototype.tick = function tick() {
	        var _this2 = this;
	
	        if (!this.typewrite) {
	            return;
	        }
	        var i = this.state.loopNum % this.state.toRotate.length;
	        var fullTxt = this.state.toRotate[i];
	
	        if (this.isDeleting) {
	            this.setState({ txt: fullTxt.substring(0, this.state.txt.length - 1) });
	        } else {
	            this.setState({ txt: fullTxt.substring(0, this.state.txt.length + 1) });
	        }
	        var delta = 200 - Math.random() * 100;
	
	        if (this.isDeleting) {
	            delta /= 2;
	        }
	
	        if (!this.isDeleting && this.state.txt === fullTxt) {
	            delta = this.state.period;
	            this.isDeleting = true;
	        } else if (this.isDeleting && this.state.txt === '') {
	            this.isDeleting = false;
	            this.setState({
	                loopNum: this.state.loopNum + 1
	            });
	            delta = 500;
	        }
	
	        setTimeout(function () {
	            _this2.tick();
	        }, delta);
	    };
	
	    Typing.prototype.componentDidMount = function componentDidMount() {
	        this.TextType();
	    };
	
	    Typing.prototype.render = function render() {
	        var _this3 = this;
	
	        return _react2.default.createElement(
	            'span',
	            { className: 'typewrite' },
	            _react2.default.createElement(
	                'span',
	                { className: 'wrap', ref: function ref(type) {
	                        return _this3.typewrite = type;
	                    } },
	                this.state.txt
	            )
	        );
	    };
	
	    return Typing;
	}(_react2.default.Component);
	
	exports.default = Typing;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RequestDemo = exports.DashbordCarousel = exports.InfoItemView = exports.MobileViewComponent = exports.LandingPage = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(73);
	
	var _phone2x = __webpack_require__(199);
	
	var _phone2x2 = _interopRequireDefault(_phone2x);
	
	var _slide022x = __webpack_require__(198);
	
	var _slide022x2 = _interopRequireDefault(_slide022x);
	
	var _reactAliceCarousel = __webpack_require__(12);
	
	var _reactAliceCarousel2 = _interopRequireDefault(_reactAliceCarousel);
	
	var _Popup = __webpack_require__(167);
	
	var _ActiveWrapper = __webpack_require__(17);
	
	var _ActiveWrapper2 = _interopRequireDefault(_ActiveWrapper);
	
	var _spaniel = __webpack_require__(288);
	
	var _info = __webpack_require__(290);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _group3Copy = __webpack_require__(190);
	
	var _group3Copy2 = _interopRequireDefault(_group3Copy);
	
	var _group32x = __webpack_require__(191);
	
	var _group32x2 = _interopRequireDefault(_group32x);
	
	var _card152x = __webpack_require__(189);
	
	var _card152x2 = _interopRequireDefault(_card152x);
	
	var _mobilePhone = __webpack_require__(192);
	
	var _mobilePhone2 = _interopRequireDefault(_mobilePhone);
	
	var _mobilePhone3 = __webpack_require__(193);
	
	var _mobilePhone4 = _interopRequireDefault(_mobilePhone3);
	
	var _mobilePhone5 = __webpack_require__(194);
	
	var _mobilePhone6 = _interopRequireDefault(_mobilePhone5);
	
	var _mobilePhone7 = __webpack_require__(196);
	
	var _mobilePhone8 = _interopRequireDefault(_mobilePhone7);
	
	var _mobilePhone9 = __webpack_require__(195);
	
	var _mobilePhone10 = _interopRequireDefault(_mobilePhone9);
	
	var _mobilePhone11 = __webpack_require__(197);
	
	var _mobilePhone12 = _interopRequireDefault(_mobilePhone11);
	
	var _axios = __webpack_require__(31);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _domain = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var regix = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	var responsive = {
	    0: {
	        items: 1
	    }
	};
	
	var LandingPage = exports.LandingPage = function (_Component) {
	    _inherits(LandingPage, _Component);
	
	    function LandingPage() {
	        _classCallCheck(this, LandingPage);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    LandingPage.prototype.closePopup = function closePopup() {
	        this.requestDemo.closePopup();
	    };
	
	    LandingPage.prototype.render = function render() {
	        var _this2 = this;
	
	        var content = this.props.content;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'products' },
	            _react2.default.createElement(
	                'div',
	                { className: 'start-mobile' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'start-content', id: 'product' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'platform' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'platform-sub' },
	                            _react2.default.createElement('div', { className: 'logo-rect', 'data-aos': 'fade-up' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'head-info', 'data-aos': 'fade-up' },
	                                'Hubbler Connect'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'head-info-sub', 'data-aos': 'fade-up' },
	                                content.head
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { 'data-aos': 'fade-up' },
	                                content.para
	                            ),
	                            _react2.default.createElement(
	                                _Popup.Popup,
	                                { ref: function ref(demo) {
	                                        return _this2.requestDemo = demo;
	                                    } },
	                                _react2.default.createElement(
	                                    _Popup.PopupButton,
	                                    null,
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'bt-blue', 'data-aos': 'fade-up' },
	                                        'Request Demo'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _Popup.PopupBody,
	                                    { className: 'request-demo-popup' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'sub' },
	                                        _react2.default.createElement('span', { className: 'close', onClick: function onClick() {
	                                                return _this2.closePopup();
	                                            } }),
	                                        _react2.default.createElement(RequestDemo, { closePopup: this.closePopup.bind(this) })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_index.LogoSliderComponent, null)
	        );
	    };
	
	    return LandingPage;
	}(_react.Component);
	
	var MobileViewComponent = exports.MobileViewComponent = function (_Component2) {
	    _inherits(MobileViewComponent, _Component2);
	
	    function MobileViewComponent() {
	        var _temp, _this3, _ret;
	
	        _classCallCheck(this, MobileViewComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this3), _this3.state = {
	            active: 0
	        }, _temp), _possibleConstructorReturn(_this3, _ret);
	    }
	
	    MobileViewComponent.prototype.galleryItems = function galleryItems() {
	        var communityWebViewData = this.props.communityWebViewData;
	
	        return communityWebViewData.map(function (item) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'mobile-scroll-animation' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mobile-view-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-container one' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'first' },
	                            item.text[0]
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'secand', style: { background: !item.text[1] ? 'none' : 'auto' } },
	                            item.text[1]
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mobile-images' },
	                        _react2.default.createElement('img', { src: item.image })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-container two' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'first', style: { background: !item.text[2] ? 'none' : 'auto' } },
	                            item.text[2]
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'secand' },
	                            item.text[3]
	                        )
	                    )
	                )
	            );
	        });
	    };
	
	    MobileViewComponent.prototype.galleryItemsMobiles = function galleryItemsMobiles() {
	        var communityMobileViewData = this.props.communityMobileViewData;
	
	        return communityMobileViewData.map(function (item) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'mobile-view-comunity' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'image-container' },
	                    _react2.default.createElement('img', { src: item.image })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    item.name
	                )
	            );
	        });
	    };
	
	    MobileViewComponent.prototype.render = function render() {
	        var _props$headerData = this.props.headerData,
	            head = _props$headerData.head,
	            para = _props$headerData.para;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'mobile-view-component' },
	            _react2.default.createElement(
	                'div',
	                { className: 'heading', 'data-aos': 'fade-up' },
	                head
	            ),
	            _react2.default.createElement(
	                'p',
	                { 'data-aos': 'fade-up' },
	                para
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'for-web', 'data-aos': 'fade-up' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mobile-carousel' },
	                    _react2.default.createElement(_reactAliceCarousel2.default, { autoPlay: true, autoPlayInterval: 2500, duration: 600, responsive: responsive, items: this.galleryItems() })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'for-mobile', 'data-aos': 'fade-up' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mobile-carousel' },
	                    _react2.default.createElement(_reactAliceCarousel2.default, { autoPlay: true, autoPlayInterval: 2500, duration: 600, responsive: responsive, items: this.galleryItemsMobiles() })
	                )
	            )
	        );
	    };
	
	    return MobileViewComponent;
	}(_react.Component);
	
	var InfoItemView = exports.InfoItemView = function (_Component3) {
	    _inherits(InfoItemView, _Component3);
	
	    function InfoItemView() {
	        _classCallCheck(this, InfoItemView);
	
	        return _possibleConstructorReturn(this, _Component3.apply(this, arguments));
	    }
	
	    InfoItemView.prototype.render = function render() {
	        var _props$itemData = this.props.itemData,
	            title = _props$itemData.title,
	            description = _props$itemData.description,
	            image = _props$itemData.image;
	
	        return _react2.default.createElement(
	            'li',
	            { 'data-aos': 'fade-up' },
	            _react2.default.createElement(
	                'div',
	                { className: 'test' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'head' },
	                    title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'image-container' },
	                    _react2.default.createElement('img', { src: image })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    description
	                )
	            )
	        );
	    };
	
	    return InfoItemView;
	}(_react.Component);
	
	var DashbordCarousel = exports.DashbordCarousel = function (_Component4) {
	    _inherits(DashbordCarousel, _Component4);
	
	    function DashbordCarousel() {
	        _classCallCheck(this, DashbordCarousel);
	
	        return _possibleConstructorReturn(this, _Component4.apply(this, arguments));
	    }
	
	    DashbordCarousel.prototype.galleryItems = function galleryItems() {
	        var dashboardData = this.props.dashboardData;
	
	        return dashboardData.map(function (item) {
	            return _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'head' },
	                    item.name
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'image-container' },
	                    item.images.map(function (img) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'img-cls' },
	                            _react2.default.createElement('img', { src: img })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    item.discription
	                )
	            );
	        });
	    };
	
	    DashbordCarousel.prototype.galleryImageItems = function galleryImageItems(images) {
	
	        return images.map(function (item) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'img-cls' },
	                _react2.default.createElement('img', { src: item })
	            );
	        });
	    };
	
	    DashbordCarousel.prototype.render = function render() {
	        var _this6 = this;
	
	        var dashboardData = this.props.dashboardData;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'dashbord-carousel' },
	            _react2.default.createElement(
	                'div',
	                { className: 'for-web' },
	                _react2.default.createElement(_reactAliceCarousel2.default, { autoPlay: dashboardData.length === 1 ? false : true, autoPlayInterval: 2500, duration: 600, responsive: responsive, items: this.galleryItems() })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'for-mobile' },
	                this.props.dashboardData.map(function (item) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'mobile-carousel' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'head' },
	                            item.name
	                        ),
	                        _react2.default.createElement(_reactAliceCarousel2.default, { autoPlay: true, autoPlayInterval: 2500, duration: 600, responsive: responsive, items: _this6.galleryImageItems(item.images) }),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            item.discription
	                        )
	                    );
	                })
	            )
	        );
	    };
	
	    return DashbordCarousel;
	}(_react.Component);
	
	var RequestDemo = exports.RequestDemo = function (_Component5) {
	    _inherits(RequestDemo, _Component5);
	
	    function RequestDemo() {
	        var _temp2, _this7, _ret2;
	
	        _classCallCheck(this, RequestDemo);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this7 = _possibleConstructorReturn(this, _Component5.call.apply(_Component5, [this].concat(args))), _this7), _this7.state = {
	            loading: false,
	            name: '',
	            email: '',
	            mobile: '',
	            showFrom: true
	        }, _temp2), _possibleConstructorReturn(_this7, _ret2);
	    }
	
	    RequestDemo.prototype.componentDidMount = function componentDidMount() {
	        var domain = _domain.getDomain;
	        this.setState({
	            domain: domain
	        });
	    };
	
	    RequestDemo.prototype.onChangeHandler = function onChangeHandler(name, event) {
	        var _setState;
	
	        this.setState((_setState = {}, _setState[name] = event.target.value, _setState));
	    };
	
	    RequestDemo.prototype.submitValidate = function submitValidate() {
	        var _state = this.state,
	            name = _state.name,
	            email = _state.email,
	            mobile = _state.mobile;
	
	        var checkFormat = regix.test(this.state.email);
	        return name !== '' && email !== '' && checkFormat;
	    };
	
	    RequestDemo.prototype.onSubmit = function onSubmit() {
	        var _this8 = this;
	
	        var postData = _extends({}, this.state);
	        delete postData.loading;
	        delete postData.domain;
	        this.setState({
	            loading: true
	        });
	        (0, _domain.postCall)('/hubbler/demo/', postData).then(function (response) {
	            if (response.data.success) {
	                _this8.setState({
	                    loading: false,
	                    name: '',
	                    email: '',
	                    mobile: '',
	                    showFrom: false
	                });
	            } else {
	                alert(response.data.error);
	            }
	        });
	    };
	
	    RequestDemo.prototype.render = function render() {
	        var checkFormat = regix.test(this.state.email);
	        if (!this.state.showFrom) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'request-demo form-page-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-inputs-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'info-details' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'head' },
	                            'We have received your Demo request'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Our team will get back to you soon.'
	                        )
	                    )
	                )
	            );
	        }
	        return _react2.default.createElement(
	            'div',
	            { className: 'request-demo form-page-container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'head' },
	                'Request Demo'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'form-view form-inputs-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inputs-list' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inputs' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Name ',
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                '*'
	                            )
	                        ),
	                        _react2.default.createElement('input', { type: 'text', placeholder: 'e.g., John Smith', onChange: this.onChangeHandler.bind(this, 'name'), disabled: this.state.loading ? true : false, value: this.state.name, autoComplete: 'off' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inputs' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Company Email ',
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                '*'
	                            )
	                        ),
	                        _react2.default.createElement('input', { type: 'text', placeholder: 'name@company.com', onChange: this.onChangeHandler.bind(this, 'email'), disabled: this.state.loading ? true : false, value: this.state.email, autoComplete: 'off' }),
	                        checkFormat || this.state.email === '' ? '' : _react2.default.createElement(
	                            'span',
	                            { className: 'text-danger' },
	                            'email format is not correct'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inputs' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            'Phone No'
	                        ),
	                        _react2.default.createElement('input', { type: 'number', placeholder: '+91 9988 766 554', onChange: this.onChangeHandler.bind(this, 'mobile'), disabled: this.state.loading ? true : false, value: this.state.mobile, autoComplete: 'off' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'footer' },
	                        _react2.default.createElement(
	                            'button',
	                            { href: '', tabIndex: this.submitValidate() ? 0 : -1, className: this.submitValidate() ? 'submit bt-blue' : 'submit bt-blue disable', id: this.state.loading ? 'bt-loading' : '', onClick: this.onSubmit.bind(this) },
	                            'Request Demo'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return RequestDemo;
	}(_react.Component);

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aos = __webpack_require__(30);
	
	var _aos2 = _interopRequireDefault(_aos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MiniProtal = function (_Component) {
	    _inherits(MiniProtal, _Component);
	
	    function MiniProtal() {
	        _classCallCheck(this, MiniProtal);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    MiniProtal.prototype.componentDidMount = function componentDidMount() {
	        this.aos = _aos2.default;
	        this.aos.init({
	            duration: 1500,
	            once: true
	        });
	    };
	
	    MiniProtal.prototype.componentDidUpdate = function componentDidUpdate() {
	        this.aos.refresh();
	    };
	
	    MiniProtal.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            'MiniProtal'
	        );
	    };
	
	    return MiniProtal;
	}(_react.Component);
	
	exports.default = MiniProtal;
	module.exports = exports['default'];

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.dashboardData = exports.communityMobileViewData = exports.communityWebViewData = exports.infoList2 = exports.infoList1 = undefined;
	
	var _info = __webpack_require__(819);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _info3 = __webpack_require__(825);
	
	var _info4 = _interopRequireDefault(_info3);
	
	var _info5 = __webpack_require__(826);
	
	var _info6 = _interopRequireDefault(_info5);
	
	var _info7 = __webpack_require__(827);
	
	var _info8 = _interopRequireDefault(_info7);
	
	var _info9 = __webpack_require__(828);
	
	var _info10 = _interopRequireDefault(_info9);
	
	var _info11 = __webpack_require__(829);
	
	var _info12 = _interopRequireDefault(_info11);
	
	var _info13 = __webpack_require__(830);
	
	var _info14 = _interopRequireDefault(_info13);
	
	var _info15 = __webpack_require__(831);
	
	var _info16 = _interopRequireDefault(_info15);
	
	var _info17 = __webpack_require__(832);
	
	var _info18 = _interopRequireDefault(_info17);
	
	var _info19 = __webpack_require__(820);
	
	var _info20 = _interopRequireDefault(_info19);
	
	var _info21 = __webpack_require__(821);
	
	var _info22 = _interopRequireDefault(_info21);
	
	var _info23 = __webpack_require__(822);
	
	var _info24 = _interopRequireDefault(_info23);
	
	var _info25 = __webpack_require__(823);
	
	var _info26 = _interopRequireDefault(_info25);
	
	var _info27 = __webpack_require__(824);
	
	var _info28 = _interopRequireDefault(_info27);
	
	var _phone2x = __webpack_require__(199);
	
	var _phone2x2 = _interopRequireDefault(_phone2x);
	
	var _slide022x = __webpack_require__(198);
	
	var _slide022x2 = _interopRequireDefault(_slide022x);
	
	var _mobilePhone = __webpack_require__(192);
	
	var _mobilePhone2 = _interopRequireDefault(_mobilePhone);
	
	var _mobilePhone3 = __webpack_require__(193);
	
	var _mobilePhone4 = _interopRequireDefault(_mobilePhone3);
	
	var _mobilePhone5 = __webpack_require__(194);
	
	var _mobilePhone6 = _interopRequireDefault(_mobilePhone5);
	
	var _mobilePhone7 = __webpack_require__(196);
	
	var _mobilePhone8 = _interopRequireDefault(_mobilePhone7);
	
	var _mobilePhone9 = __webpack_require__(195);
	
	var _mobilePhone10 = _interopRequireDefault(_mobilePhone9);
	
	var _mobilePhone11 = __webpack_require__(197);
	
	var _mobilePhone12 = _interopRequireDefault(_mobilePhone11);
	
	var _group3Copy = __webpack_require__(190);
	
	var _group3Copy2 = _interopRequireDefault(_group3Copy);
	
	var _group32x = __webpack_require__(191);
	
	var _group32x2 = _interopRequireDefault(_group32x);
	
	var _card152x = __webpack_require__(189);
	
	var _card152x2 = _interopRequireDefault(_card152x);
	
	var _claimsCopy2x = __webpack_require__(847);
	
	var _claimsCopy2x2 = _interopRequireDefault(_claimsCopy2x);
	
	var _claims2x = __webpack_require__(848);
	
	var _claims2x2 = _interopRequireDefault(_claims2x);
	
	var _tasks2x = __webpack_require__(849);
	
	var _tasks2x2 = _interopRequireDefault(_tasks2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var infoList1 = exports.infoList1 = [{
	    id: '1',
	    image: _info2.default,
	    title: 'Special Interest Groups',
	    description: 'No more dozens of WhatsApp groups to track and manage. Create,' + ' publish, find and connect with all your special interest groups in one place. Be within the larger scope of your community & in parallel,' + ' within your small & yet very focussed interest groups, that is most relevant.'
	}, {
	    id: '2',
	    image: _info4.default,
	    title: 'Events / Workshop',
	    description: 'Large or small, restricted or public - manage events like a pro. Create and share event agenda.' + ' Members mark their attendance with the check-in feature - you get the attendee list in real time. Also digitize event feedback right here on Hubbler.'
	}, {
	    id: '3',
	    image: _info6.default,
	    title: 'Members Directory',
	    description: 'Find any fellow global or local Member based on Profile, Industry, Skills or Location. When you are travelling, the app will show the members nearest to your location. In a click, you can connect with your community members who are closer to your current location. You can choose to contact them by looking at their profile information.' + ' Networking has never been easier!'
	}, {
	    id: '4',
	    image: _info8.default,
	    title: 'Profile',
	    description: 'Get to know the members. From their business, to the industries, skills, interest,  learning needs and family. Been just smiling or saying hello? Get from being acquaintances to friends. Profile information helps you connect with like minded members & network better for a mutual benefit or for business connects.'
	}];
	
	var infoList2 = exports.infoList2 = [{
	    id: '1',
	    image: _info10.default,
	    title: 'Renew Reminder',
	    description: 'Create polls, get peer opinions on issues that matter to you without needing to send out a ton of mails.'
	}, {
	    id: '2',
	    image: _info12.default,
	    title: 'User Onboarding',
	    description: 'Everything on your ballot, in your mobile! From administrative measures to ballot measures to voting rights, access everything on your entire ballot that you\'ll see in the voting booth.'
	}, {
	    id: '3',
	    image: _info14.default,
	    title: 'Polls',
	    description: 'Create polls, get peer opinions on issues that matter to you without needing to send out a ton of mails.'
	}, {
	    id: '4',
	    image: _info16.default,
	    title: 'Marketplace',
	    description: 'This is where you get what Alexa & Siri flounder to give you. Reach out to your peers when you need something or you wish to share something.'
	}, {
	    id: '5',
	    image: _info18.default,
	    title: 'Benefits & Alliances',
	    description: 'Never miss out on a deal or an opportunity which otherwise gets lost in mountains of mails and messages. Sponsors, deals, opportunities - global or local - all are here waiting for you to notice them.'
	}, {
	    id: '6',
	    image: _info20.default,
	    title: 'Vote',
	    description: 'Everything on your ballot, in your mobile! From administrative measures to ballot measures to voting rights, access everything on your entire ballot that you\'ll see in the voting booth.'
	}, {
	    id: '7',
	    image: _info22.default,
	    title: 'Global Community',
	    description: 'The best part of Hubbler Connect is the Global Platform that it is. This platform is ready to integrate your worldwide network and connect the large community through this trestle.'
	}, {
	    id: '8',
	    image: _info24.default,
	    title: 'Sponsored Channels',
	    description: 'Communities can have sponsorship channels, wherein they share deals, offers, new launches, etc. for the members consumption.'
	}, {
	    id: '9',
	    image: _info26.default,
	    title: 'Library',
	    description: 'Whether your employees are avid book readers, magazine readers, or newspaper readers; You can put 100s of e-books at their fingertips!'
	}, {
	    id: '10',
	    image: _info28.default,
	    title: 'Channels',
	    description: 'Channels allow communities to share announcements, updates,etc. Channels could also be created by members for other members to be updated based upon their common interests, passion.'
	}];
	
	var communityWebViewData = exports.communityWebViewData = [{
	    id: '1',
	    image: _phone2x2.default,
	    text: ['Quick access to favourite apps', 'Find an event of your interest, happening around you, whether at home or travelling.', 'See the data that matters', 'Celebrate successes and milestones - yours and your fellow Community members!\n' + '                            Latest updates on your Chapter members and others whom you follow ']
	}, {
	    id: '2',
	    image: _slide022x2.default,
	    text: ['Welcome the new members. Get to know them', '', '', 'Birthday / Anniversary Alerts\n' + 'Wish on time - every time']
	}];
	
	var communityMobileViewData = exports.communityMobileViewData = [{ id: '1', image: _mobilePhone2.default, name: 'Quick access to favourite apps' }, { id: '2', image: _mobilePhone4.default, name: 'See the data that matters' }, {
	    id: '3',
	    image: _mobilePhone6.default,
	    name: 'Find an event of your interest, happening around you, whether at home or travelling.'
	}, {
	    id: '4',
	    image: _mobilePhone8.default,
	    name: 'Celebrate successes and milestones - yours and your fellow Community members!'
	}, { id: '5', image: _mobilePhone10.default, name: 'Welcome the new members. Get to know them' }, {
	    id: '6', image: _mobilePhone12.default, name: 'Birthday / Anniversary Alerts\n' + 'Wish on time - every time'
	}];
	
	var dashboardData = exports.dashboardData = [{
	    id: '1',
	    name: 'Members Insight',
	    discription: 'More from the Core. We have built tools that will throw up information about your chapter’s activities and provide you with insight about events, SIG and member integration. Know the member interests, participation numbers etc.. Measure everything that was previously immeasurable & get into the details from an impact measure in real time & get periodic KPI’s in your inbox.',
	    images: [_group3Copy2.default, _group32x2.default, _card152x2.default]
	}, {
	    id: '2',
	    name: 'Admin Insight',
	    discription: 'Who doesn\'t wish to manage their operational affairs better! Let Hubbler assist you in giving you insights on your events, be it knowing the most popular to the best ranked speakers. All insights are drill down for multi-level details.',
	    images: [_claimsCopy2x2.default, _claims2x2.default, _tasks2x2.default]
	}];

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var data = exports.data = [{
	    id: '0',
	    description: 'Do I know enough about my customers?  ',
	    className: 'leadership',
	    bgColor: '#034EA2',
	    tag: 'hrID',
	    bgImage: 'img1'
	}, {
	    id: '1',
	    description: 'Who are  my top 10 customers? ',
	    bgColor: '#034EA2',
	    className: 'leadership',
	    bgImage: 'img1'
	}, {
	    id: '2',
	    description: 'What do I do with those tons of early morning reports?',
	    bgColor: '#034EA2',
	    className: 'leadership',
	    bgImage: 'img1'
	}, {
	    id: '3',
	    description: 'What’s my funnel this month? ',
	    bgColor: '#812990',
	    className: 'sales',
	    tag: 'hrID',
	    bgImage: 'img2'
	}, {
	    id: '4',
	    description: 'Do I have enough leads to meet this month’s target?',
	    bgColor: '#812990',
	    className: 'sales',
	    bgImage: 'img2'
	}, {
	    id: '5',
	    description: 'Can you remind me about the customer calls to be made?',
	    bgColor: '#812990',
	    className: 'sales',
	    bgImage: 'img2'
	}, {
	    id: '6',
	    description: 'How can I manage incentives effectively?',
	    bgColor: '#812990',
	    className: 'sales',
	    tag: 'financeId',
	    bgImage: 'img2'
	}, {
	    id: '7',
	    description: 'Can I digitise my employee on-boarding process?',
	    bgColor: '#CBDB2A',
	    className: 'hr',
	    bgImage: 'img3'
	}, {
	    id: '8',
	    description: 'How do I make sure I get consistent feedback from my employees?',
	    bgColor: '#CBDB2A',
	    className: 'hr',
	    bgImage: 'img3'
	}, {
	    id: '9',
	    description: 'Can I engage with my employees and get quick insights?',
	    bgColor: '#CBDB2A',
	    className: 'hr',
	    tag: 'salesId',
	    bgImage: 'img3'
	}, {
	    id: '10',
	    description: 'Can I tightly follow my customer deliveries?',
	    bgColor: '#F79434',
	    className: 'operations',
	    bgImage: 'img4'
	}, {
	    id: '11',
	    description: 'How can I make sure all customers are responded on time?',
	    bgColor: '#F79434',
	    className: 'operations',
	    bgImage: 'img4'
	}, {
	    id: '12',
	    description: 'Can I get to see my field service team in real-time and assign them tasks',
	    bgColor: '#F79434',
	    className: 'operations',
	    bgImage: 'img4'
	}, {
	    id: '13',
	    description: 'How do I manage employee claims at ease?',
	    bgColor: '#20BEC6',
	    className: 'finance',
	    bgImage: 'img5'
	}, {
	    id: '14',
	    description: 'Can I digitise my vendor on-boarding, PO generation and Asset Management?',
	    bgColor: '#20BEC6',
	    className: 'finance',
	    bgImage: 'img5'
	}, {
	    id: '15',
	    description: 'Are we on track with our collection targets?',
	    bgColor: '#20BEC6',
	    className: 'finance',
	    bgImage: 'img5'
	}, {
	    id: '16',
	    description: 'Can I have one platform to manage all the different processes?',
	    bgColor: '#009C56',
	    className: 'technology',
	    bgImage: 'img6'
	}, {
	    id: '17',
	    description: 'Can I quickly see the health of all the projects running in one place?',
	    bgColor: '#009C56',
	    className: 'technology',
	    bgImage: 'img6'
	}];
	
	var customiseYourApp = {
	    id: '1',
	    description: 'Manage Projects and tasks seamlessly to keep everyone in the loop',
	    app: 'hr',
	    title: 'Build your own',
	    image: 'buildYourOwn',
	    noClick: true
	};
	
	var appsData = exports.appsData = [{
	    id: '1',
	    description: 'A swipe is all it takes. It is as easy as it gets',
	    app: 'hr',
	    title: 'Attendance/Leave  ',
	    image: 'attendance'
	}, {
	    id: '2',
	    description: 'Create - distribute - collect - analyse - manage all your surveys on a single platform',
	    title: 'Survey/Feedback',
	    app: 'hr',
	    image: 'survey'
	}, {
	    id: '3',
	    description: 'Connect, Engage, Celebrate and more. A social tool with a purpose',
	    title: 'Social',
	    app: 'hr',
	    image: 'social'
	}, {
	    id: '4',
	    description: 'Stackup great applicants by empowering your employees with a supercharged referral program',
	    app: 'hr',
	    title: 'Referral Program',
	    image: 'referal'
	}, {
	    id: '5',
	    description: 'Track your teams\' learning needs, find in-house talents. A simplified tool for all learning initiatives',
	    title: 'Learning',
	    app: 'hr',
	    image: 'learning'
	}, {
	    id: '6',
	    description: 'From planning your business trips to approvals all under one roof',
	    app: 'admin',
	    title: 'Travel Management',
	    image: ''
	}, {
	    id: '7',
	    description: 'A clean and intuitive project management tool for teams of any size',
	    title: 'Projects & Tasks',
	    app: 'admin',
	    image: 'projectAndtask'
	}, {
	    id: '8',
	    description: 'No more of those thick registers and email approvals. Manage your visitors digitally',
	    title: 'Visitor Management',
	    app: 'admin',
	    image: ''
	}, {
	    id: '9',
	    description: 'Manage the security personnel deployment with comprehensive incident reporting and more',
	    app: 'admin',
	    title: 'Security',
	    image: 'security'
	}, {
	    id: '10',
	    description: 'A communication system that allows to deliver instant alerts to the right people in case of emergencies.',
	    title: 'SoS',
	    app: 'admin',
	    image: ''
	}, {
	    id: '11',
	    description: 'Simple, secure billing & invoicing solution on-the-go with hubbler',
	    title: 'Billing ',
	    app: 'finance',
	    image: 'billing'
	}, {
	    id: '12',
	    description: 'Be efficient and get paid faster with hubbler collections',
	    title: 'Collections',
	    app: 'finance',
	    image: 'collection'
	}, {
	    id: '13',
	    description: 'Can my entire sales force be accounted for in a single place ?',
	    title: 'Purchase Requisition',
	    app: 'finance',
	    image: 'purchaseRequest'
	}, {
	    id: '14',
	    description: 'A solution that helps organisations with better visibility across books of business.',
	    title: 'Claims',
	    app: 'finance',
	    image: 'claims'
	}, {
	    id: '15',
	    description: 'Optimize management policies/strategies by tracking the fixed & mobile assets of the company',
	    title: 'Asset Management',
	    app: 'finance',
	    image: 'AssetMgt'
	}, {
	    id: '16',
	    description: 'Don\'t just manage issues but seek greater visibility to resolve the root cause',
	    app: 'service',
	    title: 'Service Ticketing ',
	    image: 'serviceTicketing'
	}, {
	    id: '17',
	    description: 'A clean and intuitive project management tool for teams of any size',
	    title: 'Projects and Tasks',
	    app: 'service',
	    image: 'projectAndtask'
	}, {
	    id: '18',
	    description: 'Take advantage of real-time location of your teams. Assign jobs to the sales executive nearest to the customer.',
	    title: 'Location Management',
	    app: 'service',
	    image: 'location'
	}, {
	    id: '19',
	    description: 'From the order taking to the product delivery, on a single platform. No more loose ends',
	    app: 'service',
	    title: 'Delivery',
	    image: 'delivery'
	}, {
	    id: '20',
	    description: 'Integrate and automate sales, marketing and customer support. Suitable for business of all sizes and industries. ',
	    app: 'service',
	    title: 'CRM',
	    image: 'crm'
	}, {
	    id: '21',
	    description: 'From generating an opportunity to onboarding - capture the entire life cycle of your customer.',
	    title: 'Lead Tracker',
	    app: 'sales',
	    image: 'leadTracker'
	}, {
	    id: '22',
	    description: 'Centralise your entire customer database. Assign and distribute customers effectively to your sales team.',
	    title: 'Customer Management',
	    app: 'sales',
	    image: 'customerManagement'
	}, {
	    id: '23',
	    description: 'Give your team visibility to their targets and their achievements as they make more wins.',
	    title: 'Incentives',
	    app: 'sales',
	    image: 'incentives'
	}, {
	    id: '24',
	    description: 'Take advantage of real-time location of your team, assign new tasks / jobs to the sales executive nearest to the customer.',
	    title: 'Location Management',
	    app: 'sales',
	    image: 'location'
	}, {
	    id: '25',
	    description: 'Now get the distributors, retailers on to the same platform. Manage their sales, performance and their offers in real-time.',
	    title: 'Distributor Management',
	    app: 'sales',
	    image: 'distributorMgt'
	}, {
	    id: '26',
	    description: 'Get rid of those paper books. Now take orders with real-time visibility of inventory. All with a few taps.',
	    title: 'Order Management',
	    app: 'operations',
	    image: 'orderMngt'
	}, {
	    id: '27',
	    description: 'Centralised repository of your vendors. Create your own process and onboard your vendors.',
	    title: 'Vendor Management ',
	    app: 'operations',
	    image: 'customerIcon'
	}, {
	    id: '28',
	    description: 'Buy, sell or book - whatever your business is, our inventory can handle all complexities.',
	    title: 'Inventory Management',
	    app: 'operations',
	    image: 'inventory'
	}, {
	    id: '29',
	    description: 'Take advantage of real-time location of your team, assign new tasks / jobs to the operations executive nearest to the customer.',
	    title: 'Location Management',
	    app: 'operations',
	    image: 'location'
	}, {
	    id: '30',
	    description: 'A clean and intuitive project management tool for teams of any size.',
	    title: 'Projects & Tasks',
	    app: 'operations',
	    image: 'projectAndtask'
	}, _extends({}, customiseYourApp, { id: '31', app: 'hr'
	}), _extends({}, customiseYourApp, { id: '32', app: 'operations'
	}), _extends({}, customiseYourApp, { id: '33', app: 'sales'
	}), _extends({}, customiseYourApp, { id: '34', app: 'service'
	}), _extends({}, customiseYourApp, { id: '35', app: 'finance'
	}), _extends({}, customiseYourApp, { id: '36', app: 'admin'
	})];
	
	var hubblerReviewData = exports.hubblerReviewData = [{
	    id: '1',
	    description: 'For me, stability & growth is everything across my businesses; While ERPs sync processes; I review growth through Hubbler’s Analytical Dashboard. Precise insights from innumerable data points. A true savior!',
	    name: 'Ravi Machani\n      MD, Machani Group'
	}, {
	    id: '2',
	    description: 'Hubbler has revolutionized the way we collaborate, interact and report within our organization. Their team is young, energetic, extremely proactive to all our custom needs; we vouch for their product and team!',
	    name: 'Rachit Bhandary\n         Dir, BioMedix'
	}, {
	    id: '3',
	    description: "Hubbler's Lead Management has given us a real time view of our funnel, deal status and revenue. Substantial time on reviewing excel sheets is now used far more productively. Our swift decisions has ensured faster deal closures!",
	    name: 'Maharishi Sridhar\n          Dir, Syncotts Sports'
	}, {
	    id: '4',
	    description: 'Hubbler has exceeded our expectations! Amazed by the many Hubbler features such as attendance, leave forms, reimbursement etc., which  simplifies administration.',
	    name: 'Dr. Sanchita\n            Dept of Community Oncology'
	}];
	
	var hubblerStudioData = exports.hubblerStudioData = [{
	    id: '1',
	    description: 'It all starts with an idea',
	    title: 'Start',
	    activeLabel: 'studioActive'
	}, {
	    id: '2',
	    description: 'Decide data points to capture at every stage',
	    title: 'Create'
	}, {
	    id: '3',
	    description: 'Connect all stages together  ',
	    title: 'Link'
	}, {
	    id: '4',
	    description: 'Assign right people ',
	    title: 'Allocate'
	}, {
	    id: '5',
	    description: 'Done, already!',
	    title: 'Publish'
	}];
	
	var companyLogos = exports.companyLogos = [{ id: '1', imageName: '1', companyName: '1' }, { id: '2', imageName: '2', companyName: '2' }, { id: '3', imageName: '3', companyName: '3' }, { id: '3', imageName: '3', companyName: '3' }, { id: '4', imageName: '4', companyName: '4' }, { id: '5', imageName: '5', companyName: '5' }, { id: '6', imageName: '6', companyName: '6' }, { id: '7', imageName: '7', companyName: '7' }];

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fS5jbHMtMSwuY2xzLTJ7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMntmaWxsOm5vbmU7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDI5PC90aXRsZT48ZyBpZD0iQXNzZXRfTWFuYWdlbWVudCIgZGF0YS1uYW1lPSJBc3NldCBNYW5hZ2VtZW50Ij48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTEuNzMgMTEuMjEgMzcuNjggMTEuMjEgNDguNyAyMi4yMyAyNi4yIDQ0Ljc0IDAuODkgMjMuNDQgMTEuNzMgMTEuMjEiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSIwLjg5IiB5MT0iMjMuNDQiIHgyPSI0OC43IiB5Mj0iMjIuMjQiLz48cG9seWxpbmUgY2xhc3M9ImNscy0yIiBwb2ludHM9IjE5LjA2IDExLjIxIDE1LjkxIDIzLjA2IDI2LjIgNDQuNzQiLz48cG9seWxpbmUgY2xhc3M9ImNscy0yIiBwb2ludHM9IjMzLjA1IDExLjIxIDM2LjIgMjMuMDYgMjUuOTEgNDQuNzQiLz48L2c+PC9zdmc+"

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/AssetMgt.503c7d1a.png";

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Referrals.214cb583.png";

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMSwuY2xzLTJ7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BdHRlYW5kYW5jZSBMZWF2ZTwvdGl0bGU+PGcgaWQ9IkF0dGVuZGFjZV9MZWF2ZS5zdmciIGRhdGEtbmFtZT0iQXR0ZW5kYWNlIExlYXZlLnN2ZyI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzEuMzUsMzcuMjNjMC05LjQ0LTQuNjUtMTcuMDktMTAuNC0xNy4wOXMtMTAuNCw3LjY1LTEwLjQsMTcuMDloMGEyMiwyMiwwLDAsMCwyMC43OSwwWiIvPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iMjAuOTUiIGN5PSIxNC44MSIgcj0iNy40NiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTMxLjU4LDI5YTYuODEsNi44MSwwLDEsMCw1LjUsMTAuODIiLz48cG9seWxpbmUgY2xhc3M9ImNscy0xIiBwb2ludHM9IjMwLjE2IDM1LjI2IDMyLjAzIDM3LjEzIDM5LjQ0IDI5LjcyIi8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/attendance.99c807e9.png";

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMSwuY2xzLTJ7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDI1PC90aXRsZT48ZyBpZD0iQmlsbGluZyI+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSI3LjAzIiB5PSIxLjYxIiB3aWR0aD0iMzUuNTMiIGhlaWdodD0iNDkuMjEiLz48bGluZSBjbGFzcz0iY2xzLTIiIHgxPSIxNC42OSIgeTE9IjExLjk5IiB4Mj0iMzQuOTEiIHkyPSIxMS45OSIvPjxsaW5lIGNsYXNzPSJjbHMtMiIgeDE9IjE4LjEzIiB5MT0iMjAuNTUiIHgyPSIzMS40NiIgeTI9IjIwLjU1Ii8+PGxpbmUgY2xhc3M9ImNscy0yIiB4MT0iMjEuNDYiIHkxPSI0Mi42NiIgeDI9IjI4LjEzIiB5Mj0iNDIuNjYiLz48L2c+PC9zdmc+"

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/billing.0c2cac1d.png";

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMSwuY2xzLTJ7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDI4PC90aXRsZT48ZyBpZD0iQ2xhaW1zIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zNS4yMSwzNC41M2MwLTkuNDQtNC42NS0xNy4wOS0xMC40LTE3LjA5cy0xMC40LDcuNjUtMTAuNCwxNy4wOWgwYTIyLDIyLDAsMCwwLDIwLjc5LDBaIi8+PGNpcmNsZSBjbGFzcz0iY2xzLTIiIGN4PSIyNC44MSIgY3k9IjEyLjEyIiByPSI3LjQ2Ii8+PGVsbGlwc2UgY2xhc3M9ImNscy0yIiBjeD0iMzQuOTQiIGN5PSI0MC4xNyIgcng9IjguNjMiIHJ5PSI0LjE1Ii8+PGVsbGlwc2UgY2xhc3M9ImNscy0yIiBjeD0iMzQuOTQiIGN5PSIzNS4xNyIgcng9IjguNjMiIHJ5PSI0LjE1Ii8+PGVsbGlwc2UgY2xhc3M9ImNscy0yIiBjeD0iMzQuOTQiIGN5PSIzMC4xNyIgcng9IjguNjMiIHJ5PSI0LjE1Ii8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/claims.36a029d4.png";

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDI2PC90aXRsZT48ZyBpZD0iQ29sbGVjdGlvbnMiPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iOS4zMiIgeT0iMy4wNyIgd2lkdGg9IjMwLjY3IiBoZWlnaHQ9IjI4LjE3Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSI0Ljc3IiB5PSI5LjA3IiB3aWR0aD0iMzkuNzgiIGhlaWdodD0iMzAuMTciLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjEuNDIiIHk9IjE1LjA3IiB3aWR0aD0iNDYuNzQiIGhlaWdodD0iMjkuNjgiLz48L2c+PC9zdmc+"

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/collection.8b9eaf79.png";

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOTRweCIgaGVpZ2h0PSI5NHB4IiB2aWV3Qm94PSIwIDAgOTQgOTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjIgKDU3NTE5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5jcm0taWNvbjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxsaW5lYXJHcmFkaWVudCB4MT0iMTE0LjM5Mjg3MyUiIHkxPSItMTguMDEwNjM2OSUiIHgyPSIxOC43MDMyMDg5JSIgeTI9IjgzLjA1NDg1MTQlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNGRERCODMiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0ZCNjc1OSIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJJdGVyYXRpb24tMiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlNlcnZpY2VzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE4LjAwMDAwMCwgLTExNi4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9ImNybS1pY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MTguMDAwMDAwLCAxMTYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjQuMTAzNzExMiwwIEMxMC43OTE5MDM3LDAgMCwxMC43OTE5MDM3IDAsMjQuMTA0MjEzOSBMMCw2OS40MDIxNjA0IEMwLDgyLjcxNDk3MzMgMTAuNzkxOTAzNyw5My41MDYzNzQzIDI0LjEwMzcxMTIsOTMuNTA2Mzc0MyBMNjkuNDAyMTYwNCw5My41MDYzNzQzIEM4Mi43MTQ0NzA2LDkzLjUwNjM3NDMgOTMuNTA2ODc3LDgyLjcxNDk3MzMgOTMuNTA2ODc3LDY5LjQwMjE2MDQgTDkzLjUwNjg3NywyNC4xMDQyMTM5IEM5My41MDY4NzcsMTAuNzkxOTAzNyA4Mi43MTQ0NzA2LDAgNjkuNDAyMTYwNCwwIEwyNC4xMDM3MTEyLDAgWiIgaWQ9IkZpbGwtMjQiIGZpbGw9InVybCgjbGluZWFyR3JhZGllbnQtMSkiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNC4yMTAxMTQzLDQ5Ljc3MTA3NjkgQzE0LjM1MDE5MDUsNTAuMDUxMjI5MyAxNC42MzAzNDI4LDUwLjMzMTM4MTcgMTQuOTEwNDk1Miw1MC40MDE0MTk4IEwyMy43MzUyOTUsNTMuNDEzMDU3OCBDMjMuODc1MzcxMiw1My40ODMwOTU5IDI0LjAxNTQ0NzQsNTMuNDgzMDk1OSAyNC4xNTU1MjM2LDUzLjQ4MzA5NTkgQzI0LjcxNTgyODQsNTMuNDgzMDk1OSAyNS4yMDYwOTUsNTMuMTMyOTA1NCAyNS4zNDYxNzEyLDUyLjY0MjYzODggTDMyLjI3OTk0MjUsMzIuMzMxNTkxNSBMMzIuNzcwMjA5MiwzMi40NzE2Njc3IEMzNC41MjExNjE1LDMzLjEwMjAxMDYgMzYuNDgyMjI4MSwzMi45NjE5MzQ0IDM4LjE2MzE0MjQsMzIuMTkxNTE1NCBMMzkuMDAzNTk5NSwzMS43NzEyODY4IEM0MC4wNTQxNzA5LDMxLjI4MTAyMDEgNDEuMzE0ODU2NiwzMS4yMTA5ODIgNDIuMzY1NDI4LDMxLjU2MTE3MjUgTDU4LjU0NDIyNzcsMzcuMTY0MjIgQzU4LjQwNDE1MTUsMzcuNzk0NTYyOSA1OC4wNTM5NjEsMzguNjM1MDIgNTcuNDIzNjE4MiwzOS4wNTUyNDg2IEM1Ni43MjMyMzczLDM5LjU0NTUxNTIgNTUuNjcyNjY1OCwzOS41NDU1MTUyIDU0LjM0MTk0MjEsMzkuMDU1MjQ4NiBMNDcuMTI4MDE4NCwzNi42MDM5MTUzIEM0Ni43Nzc4Mjc5LDM2LjQ2MzgzOTEgNDYuNDI3NjM3NSwzNi41MzM4NzcyIDQ2LjA3NzQ0NywzNi42NzM5NTM0IEM0NS43OTcyOTQ2LDM2LjgxNDAyOTYgNDUuNTE3MTQyMiwzNy4xNjQyMiA0NS40NDcxMDQxLDM3LjQ0NDM3MjQgQzQ1LjQ0NzEwNDEsMzcuNTE0NDEwNSA0NC4zOTY1MzI3LDQxLjIyNjQyOTUgNDEuMjQ0ODE4NSw0Mi45NzczODE4IEMzOS4yMTM3MTM4LDQ0LjAyNzk1MzIgMzYuNzYyMzgwNSw0NC4wOTc5OTEzIDMzLjgyMDc4MDYsNDMuMTE3NDU4IEMzMy4xMjAzOTk2LDQyLjkwNzM0MzcgMzIuNDIwMDE4Nyw0My4yNTc1MzQyIDMyLjIwOTkwNDQsNDMuODg3ODc3IEMzMS45OTk3OTAxLDQ0LjU4ODI1OCAzMi4zNDk5ODA2LDQ1LjI4ODYzODkgMzIuOTgwMzIzNCw0NS40OTg3NTMyIEMzNC42NjEyMzc3LDQ2LjA1OTA1NzkgMzYuMjcyMTEzOCw0Ni4zMzkyMTAzIDM3Ljc0MjkxMzgsNDYuMzM5MjEwMyBDMzkuNDIzODI4MSw0Ni4zMzkyMTAzIDQxLjAzNDcwNDIsNDUuOTg5MDE5OSA0Mi40MzU0NjYxLDQ1LjIxODYwMDggQzQ1LjMwNzAyOCw0My42Nzc3NjI4IDQ2Ljc3NzgyNzksNDEuMDE2MzE1MiA0Ny40MDgxNzA4LDM5LjQwNTQzOSBMNTMuNDMxNDQ2OCw0MS40MzY1NDM4IEM1NS42MDI2Mjc4LDQyLjIwNjk2MjggNTcuMzUzNTgwMSw0Mi4wNjY4ODY2IDU4Ljc1NDM0Miw0MS4wODYzNTMzIEM2MC45MjU1MjI5LDM5LjU0NTUxNTIgNjEuMTM1NjM3MiwzNi42MDM5MTUzIDYxLjEzNTYzNzIsMzYuMjUzNzI0OCBDNjEuMTM1NjM3MiwzNS42OTM0MjAxIDYwLjc4NTQ0NjcsMzUuMjAzMTUzNCA2MC4yOTUxOCwzNC45OTMwMzkxIEw0My4xMzU4NDcsMjkuMDM5ODAxMSBDNDEuMzg0ODk0NywyOC40MDk0NTgzIDM5LjQyMzgyODEsMjguNTQ5NTM0NSAzNy44MTI5NTE5LDI5LjM4OTk5MTYgTDM2Ljk3MjQ5NDgsMjkuODEwMjIwMiBDMzUuOTIxOTIzNCwzMC4zMDA0ODY4IDM0LjY2MTIzNzcsMzAuMzcwNTI0OSAzMy41NDA2MjgyLDMwLjAyMDMzNDUgTDMyLjEzOTg2NjMsMjkuNTMwMDY3OCBDMzIuMDY5ODI4MiwyOS40NjAwMjk3IDMxLjk5OTc5MDEsMjkuNDYwMDI5NyAzMS44NTk3MTM5LDI5LjM4OTk5MTYgTDIzLjAzNDkxNDEsMjYuMzc4MzUzNiBDMjIuMzM0NTMzMiwyNi4xNjgyMzkzIDIxLjYzNDE1MjIsMjYuNTE4NDI5OCAyMS40MjQwMzc5LDI3LjE0ODc3MjYgTDE0LDQ4LjcyMDUwNTUgQzE0LjA3MDAzODEsNDkuMTQwNzM0MSAxNC4wNzAwMzgxLDQ5LjQ5MDkyNDUgMTQuMjEwMTE0Myw0OS43NzEwNzY5IFogTTIzLjU5NTIxODksMjkuMjQ5OTE1NCBMMjkuOTY4Njg1NCwzMS40MjEwOTYzIEwyMy4zODUxMDQ2LDUwLjU0MTQ5NiBMMTcuMDExNjM4LDQ4LjM3MDMxNSBMMjMuNTk1MjE4OSwyOS4yNDk5MTU0IFogTTIyLjA1NDM4MDgsNDcuODEwMDEwMyBDMjEuODQ0MjY2NSw0OC40NDAzNTMxIDIxLjE0Mzg4NTYsNDguNzkwNTQzNiAyMC41MTM1NDI3LDQ4LjU4MDQyOTMgQzE5Ljg4MzE5OTksNDguMzcwMzE1IDE5LjUzMzAwOTQsNDcuNjY5OTM0MSAxOS43NDMxMjM3LDQ3LjAzOTU5MTMgQzE5Ljk1MzIzOCw0Ni40MDkyNDg0IDIwLjY1MzYxODksNDYuMDU5MDU3OSAyMS4yODM5NjE4LDQ2LjI2OTE3MjIgQzIxLjkxNDMwNDYsNDYuNTQ5MzI0NiAyMi4yNjQ0OTUxLDQ3LjE3OTY2NzQgMjIuMDU0MzgwOCw0Ny44MTAwMTAzIFogTTMwLjk0OTIxODcsNTMuOTAzMzI0NSBMMzcuMDQyNTMyOSw1MC44OTE2ODY0IEMzNy42NzI4NzU3LDUwLjYxMTUzNCAzNy45NTMwMjgxLDQ5Ljg0MTExNSAzNy42MDI4Mzc2LDQ5LjIxMDc3MjIgQzM3LjMyMjY4NTMsNDguNTgwNDI5MyAzNi41NTIyNjYyLDQ4LjMwMDI3NjkgMzUuOTIxOTIzNCw0OC42NTA0Njc0IEwyOS44Mjg2MDkyLDUxLjY2MjEwNTUgQzI3Ljg2NzU0MjYsNTIuNjQyNjM4OCAyNy4wMjcwODU1LDU1LjAyMzkzNCAyOC4wMDc2MTg4LDU2Ljk4NTAwMDYgQzI4LjI4Nzc3MTEsNTcuNTQ1MzA1MyAyOC43MDc5OTk3LDU4LjAzNTU3MiAyOS4xOTgyNjY0LDU4LjQ1NTgwMDYgQzI4LjI4Nzc3MTEsNTkuNjQ2NDQ4MiAyOC4wNzc2NTY5LDYxLjI1NzMyNDMgMjguNzc4MDM3OCw2Mi42NTgwODYyIEMyOS4yNjgzMDQ1LDYzLjYzODYxOTUgMzAuMDM4NzIzNSw2NC4zMzkwMDA0IDMxLjA4OTI5NDksNjQuNjg5MTkwOSBDMzEuNTA5NTIzNSw2NC44MjkyNjcxIDMxLjkyOTc1Miw2NC44OTkzMDUyIDMyLjM0OTk4MDYsNjQuODk5MzA1MiBDMzIuMzQ5OTgwNiw2NS41Mjk2NDggMzIuNDkwMDU2OCw2Ni4xNTk5OTA5IDMyLjc3MDIwOTIsNjYuNzIwMjk1NiBDMzMuNDcwNTkwMSw2OC4xMjEwNTc1IDM0Ljg3MTM1Miw2OC45NjE1MTQ2IDM2LjM0MjE1MTksNjguOTYxNTE0NiBDMzYuOTAyNDU2Nyw2OC45NjE1MTQ2IDM3LjUzMjc5OTUsNjguODIxNDM4NCAzOC4wOTMxMDQzLDY4LjU0MTI4NjEgTDM5LjAwMzU5OTUsNjguMTIxMDU3NSBDMzkuMDczNjM3Niw2OC42MTEzMjQyIDM5LjE0MzY3NTcsNjkuMDMxNTUyNyAzOS4zNTM3OSw2OS41MjE4MTk0IEM0MC4wNTQxNzA5LDcwLjkyMjU4MTMgNDEuNDU0OTMyOCw3MS43NjMwMzg0IDQyLjkyNTczMjgsNzEuNzYzMDM4NCBDNDMuNDg2MDM3NSw3MS43NjMwMzg0IDQ0LjExNjM4MDQsNzEuNjIyOTYyMiA0NC42NzY2ODUxLDcxLjM0MjgwOTggTDYwLjcxNTQwODYsNjMuNDk4NTQzMyBDNjQuMjg3MzUxNCw2MS43NDc1OTEgNjcuNTc5MTQxOCw1OS41MDYzNzIgNzAuNTIwNzQxNyw1Ni44NDQ5MjQ0IEw3NC4wOTI2ODQ1LDUzLjU1MzEzNCBMODIuMjg3MTQxNSw0OS41NjA5NjI2IEM4Mi45MTc0ODQ0LDQ5LjI4MDgxMDMgODMuMTk3NjM2Nyw0OC41MTAzOTEyIDgyLjg0NzQ0NjMsNDcuODgwMDQ4NCBMNzIuODMxOTk4OCwyNy40Mjg5MjUgQzcyLjY5MTkyMjcsMjcuMTQ4NzcyNiA3Mi40MTE3NzAzLDI2Ljg2ODYyMDIgNzIuMTMxNjE3OSwyNi43OTg1ODIxIEM3MS43ODE0Mjc0LDI2LjY1ODUwNTkgNzEuNDMxMjM3LDI2LjcyODU0NCA3MS4xNTEwODQ2LDI2Ljg2ODYyMDIgTDYyLjc0NjUxMzMsMzAuOTMwODI5NyBDNjIuMTE2MTcwNSwzMS4yMTA5ODIgNjEuODM2MDE4MSwzMS45ODE0MDExIDYyLjE4NjIwODYsMzIuNjExNzQzOSBMNzEuNzgxNDI3NCw1Mi4yMjI0MTAyIEw2OC43Njk3ODk0LDU1LjAyMzkzNCBDNjYuMDM4MzAzNyw1Ny41NDUzMDUzIDYyLjk1NjYyNzYsNTkuNjQ2NDQ4MiA1OS41OTQ3OTkxLDYxLjI1NzMyNDMgTDQzLjU1NjA3NTYsNjkuMTAxNTkwOCBDNDIuODU1Njk0Nyw2OS40NTE3ODEzIDQyLjAxNTIzNzUsNjkuMTcxNjI4OSA0MS42NjUwNDcxLDY4LjQ3MTI0OCBDNDEuMzE0ODU2Niw2Ny43NzA4NjcgNDEuNTk1MDA5LDY2LjkzMDQwOTkgNDIuMjk1Mzg5OSw2Ni41ODAyMTk0IEw1MS4yNjAyNjU5LDYyLjE2NzgxOTUgQzUxLjg5MDYwODgsNjEuODg3NjY3MiA1Mi4xNzA3NjEyLDYxLjExNzI0ODEgNTEuODIwNTcwNyw2MC40ODY5MDUzIEM1MS41NDA0MTgzLDU5Ljg1NjU2MjQgNTAuNzY5OTk5Myw1OS41NzY0MTAxIDUwLjEzOTY1NjQsNTkuOTI2NjAwNSBMNDEuMTc0NzgwNCw2NC4zMzkwMDA0IEwzNi45NzI0OTQ4LDY2LjM3MDEwNTIgQzM2LjI3MjExMzgsNjYuNzIwMjk1NiAzNS40MzE2NTY3LDY2LjQ0MDE0MzMgMzUuMDgxNDY2Myw2NS43Mzk3NjIzIEMzNC45NDEzOTAxLDY1LjM4OTU3MTkgMzQuODcxMzUyLDY1LjAzOTM4MTQgMzUuMDExNDI4Miw2NC42ODkxOTA5IEMzNS4xNTE1MDQzLDY0LjMzOTAwMDQgMzUuMzYxNjE4Niw2NC4wNTg4NDgxIDM1LjcxMTgwOTEsNjMuODQ4NzMzOCBMMzkuMDczNjM3Niw2Mi4yMzc4NTc2IEw0OC41OTg4MTg0LDU3LjU0NTMwNTMgQzQ5LjIyOTE2MTIsNTcuMjY1MTUzIDQ5LjUwOTMxMzYsNTYuNDk0NzMzOSA0OS4xNTkxMjMxLDU1Ljg2NDM5MTEgQzQ4Ljg3ODk3MDcsNTUuMjM0MDQ4MiA0OC4xMDg1NTE3LDU0Ljk1Mzg5NTkgNDcuNDc4MjA4OSw1NS4zMDQwODYzIEwzNy45NTMwMjgxLDU5Ljk5NjYzODYgTDM0LjU5MTE5OTYsNjEuNjA3NTE0OCBMMzIuOTgwMzIzNCw2Mi4zNzc5MzM4IEMzMi42MzAxMzMsNjIuNTE4MDEgMzIuMjc5OTQyNSw2Mi41ODgwNDgxIDMxLjkyOTc1Miw2Mi40NDc5NzE5IEMzMS41Nzk1NjE2LDYyLjMwNzg5NTcgMzEuMjk5NDA5Miw2Mi4wOTc3ODE0IDMxLjA4OTI5NDksNjEuNzQ3NTkxIEMzMC43MzkxMDQ0LDYxLjA0NzIxIDMxLjAxOTI1NjgsNjAuMjA2NzUyOSAzMS43MTk2Mzc3LDU5Ljg1NjU2MjQgTDMzLjMzMDUxMzksNTkuMDg2MTQzNCBMMzcuNDYyNzYxNCw1Ny4wNTUwMzg3IEw0NC44ODY3OTk0LDUzLjQxMzA1NzggQzQ1LjUxNzE0MjIsNTMuMTMyOTA1NCA0NS43OTcyOTQ2LDUyLjM2MjQ4NjQgNDUuNDQ3MTA0MSw1MS43MzIxNDM1IEM0NS4xNjY5NTE4LDUxLjEwMTgwMDcgNDQuMzk2NTMyNyw1MC44MjE2NDgzIDQzLjc2NjE4OTksNTEuMTcxODM4OCBMMzYuMzQyMTUxOSw1NC44MTM4MTk3IEwzMy40MDA1NTIsNTYuMjg0NjE5NiBMMzIuMjA5OTA0NCw1Ni44NDQ5MjQ0IEMzMS41MDk1MjM1LDU3LjE5NTExNDkgMzAuNjY5MDY2Myw1Ni45MTQ5NjI1IDMwLjMxODg3NTksNTYuMjE0NTgxNiBDMjkuODk4NjQ3Myw1NS4wOTM5NzIxIDMwLjI0ODgzNzgsNTQuMjUzNTE0OSAzMC45NDkyMTg3LDUzLjkwMzMyNDUgWiBNNzEuMDgxMDQ2NSwyOS40NjAwMjk3IEw3OS45NzU4ODQ0LDQ3LjU5OTg5NiBMNzMuODgyNTcwMiw1MC41NDE0OTYgTDY0Ljk4NzczMjMsMzIuNDAxNjI5NiBMNzEuMDgxMDQ2NSwyOS40NjAwMjk3IFogTTc0Ljg2MzEwMzYsNDcuNzM5OTcyMiBDNzQuNTgyOTUxMiw0Ny4xMDk2Mjk0IDc0Ljc5MzA2NTUsNDYuNDA5MjQ4NCA3NS40MjM0MDgzLDQ2LjEyOTA5NiBDNzYuMDUzNzUxMiw0NS44NDg5NDM3IDc2Ljc1NDEzMjEsNDYuMDU5MDU3OSA3Ny4wMzQyODQ1LDQ2LjY4OTQwMDggQzc3LjMxNDQzNjgsNDcuMzE5NzQzNiA3Ny4xMDQzMjI2LDQ4LjAyMDEyNDYgNzYuNDczOTc5Nyw0OC4zMDAyNzY5IEM3NS45MTM2NzUsNDguNTgwNDI5MyA3NS4xNDMyNTU5LDQ4LjMwMDI3NjkgNzQuODYzMTAzNiw0Ny43Mzk5NzIyIFoiIGlkPSJTaGFwZSIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDIxPC90aXRsZT48ZyBpZD0iVmVuZG9yX01hbmFnZW1lbnQiIGRhdGEtbmFtZT0iVmVuZG9yIE1hbmFnZW1lbnQiPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMTAuNyIgeT0iMjEuMzQiIHdpZHRoPSIzMS4zMSIgaGVpZ2h0PSI1LjkiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjEwLjciIHk9IjI3LjI0IiB3aWR0aD0iMzEuMzEiIGhlaWdodD0iMTMuMTUiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjE1LjI1IiBjeT0iNDUuMjgiIHI9IjQuMzUiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI0Mi4wMSIgeTE9IjQ5LjYyIiB4Mj0iNDIuMDEiIHkyPSIzMi4xNiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI2LjM3LDIxLjM0VjlIOC40M2wuMjMtLjIzQTI1LDI1LDAsMCwxLDQ0LDguODZoMEwyNC4zNyw5Ii8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/customer-management.4938bcc3.png";

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDE4PC90aXRsZT48ZyBpZD0iRGVsaXZlcnkiPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyNS40NCA0MC4zIDkuMzkgMzIuNDUgOS4zOSAxMy44OCAyNS40NCAyMS43MyAyNS40NCA0MC4zIi8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjI1LjA5IDQwLjMgNDEuMTQgMzIuNDUgNDEuMTQgMTMuODggMjUuMDkgMjEuNzMgMjUuMDkgNDAuMyIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSI5LjM5IDEzLjg4IDI1LjA5IDIxLjczIDQxLjE0IDEzLjg4IDI1LjQ0IDUuOTIgOS4zOSAxMy44OCIvPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjE3LjQxIiB5MT0iMTcuOSIgeDI9IjMzLjExIiB5Mj0iOS44MSIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/delivery.63b94ec2.png";

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDE0PC90aXRsZT48ZyBpZD0iRGlzdHJpYnV0b3JfTWdtdCIgZGF0YS1uYW1lPSJEaXN0cmlidXRvciBNZ210Ij48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTIuMDkgNDQuNTYgMy41OCA0MC40IDMuNTggMzAuNTYgMTIuMDkgMzQuNzIgMTIuMDkgNDQuNTYiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTEuOTEgNDQuNTYgMjAuNDIgNDAuNCAyMC40MiAzMC41NiAxMS45MSAzNC43MiAxMS45MSA0NC41NiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIzLjU4IDMwLjU2IDExLjkxIDM0LjcyIDIwLjQyIDMwLjU2IDEyLjA5IDI2LjM0IDMuNTggMzAuNTYiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMzguNjIgNDQuNTYgMzAuMTEgNDAuNCAzMC4xMSAzMC41NiAzOC42MiAzNC43MiAzOC42MiA0NC41NiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIzOC40MyA0NC41NiA0Ni45NCA0MC40IDQ2Ljk0IDMwLjU2IDM4LjQzIDM0LjcyIDM4LjQzIDQ0LjU2Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjMwLjExIDMwLjU2IDM4LjQzIDM0LjcyIDQ2Ljk0IDMwLjU2IDM4LjYyIDI2LjM0IDMwLjExIDMwLjU2Ii8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIxMS45MSAyMS4wMiAxMS45MSAxMy45NiAyNS4wMyAxMy45NiAyNS4wMyA2LjIyIDI1LjAzIDEzLjk2IDM4LjYyIDEzLjYyIDM4LjYyIDIxLjAyIi8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/distributor-mgt.76156103.png";

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDEyPC90aXRsZT48ZyBpZD0iTGVhZGVyYm9hcmRzIj48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjYuMzgiIHk9IjE5LjIxIiB3aWR0aD0iMTIuMTYiIGhlaWdodD0iMjEuMTMiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjE5Ljg1IiB5PSI4LjkzIiB3aWR0aD0iMTIuMTYiIGhlaWdodD0iMzEuNDEiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjMyLjkxIiB5PSIyOC4wMSIgd2lkdGg9IjEyLjE2IiBoZWlnaHQ9IjEyLjMzIi8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDE1PC90aXRsZT48ZyBpZD0iU2VydmljZV9UaWNrZXRpbmciIGRhdGEtbmFtZT0iU2VydmljZSBUaWNrZXRpbmciPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyMC40NyA0LjkgMjAuNDcgMTYuNzcgMTEuMTggMTYuNzcgMTEuMTggNC45IDQuMDkgMTEuOTkgNC4wOSAyMS45NCAxMC43OCAyOC42MyAxMC43OCA0MS4xNyAyMC40NyA0MS4xNyAyMC40NyAyOC44NiAyMC43IDI4Ljg2IDI3LjE1IDIyLjQxIDI3LjE1IDExLjU4IDIwLjQ3IDQuOSIvPjxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMzEuOTggMjMuMDMgNDUuNSAyMy4wMyA0NS41IDQxLjE3IDI1Ljc2IDQxLjE3Ii8+PGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iMjguODYiIHkxPSIyOC43OCIgeDI9IjQwLjA4IiB5Mj0iMjguNzgiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSIyOC44NiIgeTE9IjM0Ljc0IiB4Mj0iMzUuOTciIHkyPSIzNC43NCIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/incentives.19977d40.png";

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMSwuY2xzLTJ7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDIyPC90aXRsZT48ZyBpZD0iSW52ZW50b3J5X01hbmFnZW1lbnQiIGRhdGEtbmFtZT0iSW52ZW50b3J5IE1hbmFnZW1lbnQiPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyMi4yMyAzMy43MSA5LjM3IDI3LjQzIDkuMzcgMTIuNTYgMjIuMjMgMTguODQgMjIuMjMgMzMuNzEiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMjEuOTUgMzMuNzEgMzQuODEgMjcuNDMgMzQuODEgMTIuNTYgMjEuOTUgMTguODQgMjEuOTUgMzMuNzEiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iOS4zNyAxMi41NiAyMS45NSAxOC44NCAzNC44MSAxMi41NiAyMi4yMyA2LjE3IDkuMzcgMTIuNTYiLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMzQuOTUgNDAuMDQgMjIuMDkgMzMuNzUgMjIuMDkgMTguODkgMzQuOTUgMjUuMTcgMzQuOTUgNDAuMDQiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMzQuNjcgNDAuMDQgNDcuNTMgMzMuNzUgNDcuNTMgMTguODkgMzQuNjcgMjUuMTcgMzQuNjcgNDAuMDQiLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMjIuMDkgMTguODkgMzQuNjcgMjUuMTcgNDcuNTMgMTguODkgMzQuOTUgMTIuNSAyMi4wOSAxOC44OSIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxNC45MiA0My4yNSAyLjA2IDM2Ljk2IDIuMDYgMjIuMDkgMTQuOTIgMjguMzggMTQuOTIgNDMuMjUiLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMTQuNjQgNDMuMjUgMjcuNSAzNi45NiAyNy41IDIyLjA5IDE0LjY0IDI4LjM4IDE0LjY0IDQzLjI1Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjIuMDYgMjIuMDkgMTQuNjQgMjguMzggMjcuNSAyMi4wOSAxNC45MiAxNS43MSAyLjA2IDIyLjA5Ii8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/inventory-management.c7a1e258.png";

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMSwuY2xzLTJ7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDEwPC90aXRsZT48ZyBpZD0iTGVhZF9UcmFja2VyIiBkYXRhLW5hbWU9IkxlYWQgVHJhY2tlciI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzQuOTQsMzQuMTljMC05LjQ0LTQuNjUtMTcuMDktMTAuNC0xNy4wOXMtMTAuNCw3LjY1LTEwLjQsMTcuMDloMGEyMiwyMiwwLDAsMCwyMC43OSwwWiIvPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iMjQuNTQiIGN5PSIxMS43NyIgcj0iNy40NiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIzMi45NCAyMy42NyAzNi4zMSAzMC41IDQzLjg0IDMxLjYgMzguMzkgMzYuOTEgMzkuNjggNDQuNDEgMzIuOTQgNDAuODcgMjYuMiA0NC40MSAyNy40OSAzNi45MSAyMi4wNCAzMS42IDI5LjU3IDMwLjUgMzIuOTQgMjMuNjciLz48L2c+PC9zdmc+"

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lead-tracker.517aaa74.png";

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5MZWFybmluZzwvdGl0bGU+PGcgaWQ9IkxlYXJuaW5nIj48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMjMuNzMgMjUuOTkgOC44IDE2LjczIDIzLjczIDcuNDYgMzguNjYgMTYuNzMgMjMuNzMgMjUuOTkiLz48cG9seWxpbmUgY2xhc3M9ImNscy0xIiBwb2ludHM9IjMzLjAzIDIxLjgyIDMzLjAzIDI4LjU1IDIzLjY2IDM0LjM2IDE0LjI5IDI4LjU1IDE0LjI5IDIxLjc1Ii8+PGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iMzguNjYiIHkxPSIxNi43MyIgeDI9IjM4LjY2IiB5Mj0iMzMuOTMiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjM4LjY2IiBjeT0iMzcuMzMiIHI9IjMuMTIiLz48L2c+PC9zdmc+"

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/learning.922fcf6c.png";

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/location-mgt.3af9bc13.png";

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDEzPC90aXRsZT48ZyBpZD0iTG9jYXRpb25fTW5nbXQiIGRhdGEtbmFtZT0iTG9jYXRpb24gTW5nbXQiPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjIuMyIgY3k9IjIxLjE3IiByPSIxMSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE2LjU2LDIyLjE3YTYuNzQsNi43NCwwLDAsMSw2Ljc0LTYuNzQiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSIzMC4zNSIgeTE9IjI4LjY1IiB4Mj0iMzkuMjIiIHkyPSIzNy41MiIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/order-management.9c0039bd.png";

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDY8L3RpdGxlPjxnIGlkPSJQcm9qZWN0c19UYXNrcyIgZGF0YS1uYW1lPSJQcm9qZWN0cyAmYW1wOyBUYXNrcyI+PHBvbHlsaW5lIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIxMy43NSAxNC40NSAxNS43OSAxNi41IDIzLjE5IDkuMTEiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjI5LjMiIHk9IjkuMTEiIHdpZHRoPSIxNC4yIiBoZWlnaHQ9IjE0LjIiIHJ4PSI0LjciIHJ5PSI0LjciLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjI5LjMiIHk9IjI4Ljc4IiB3aWR0aD0iMTQuMiIgaGVpZ2h0PSIxNC4yIiByeD0iNC43IiByeT0iNC43Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSI3Ljk5IiB5PSIyOC43OCIgd2lkdGg9IjE0LjIiIGhlaWdodD0iMTQuMiIgcng9IjQuNyIgcnk9IjQuNyIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyLjE5LDE4LjZhNC43LDQuNywwLDAsMS00LjcsNC43SDEyLjY5QTQuNyw0LjcsMCwwLDEsOCwxOC42VjEzLjgxYTQuNyw0LjcsMCwwLDEsNC43LTQuNyIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/projects-n-tasks.1caa6c92.png";

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMSwuY2xzLTJ7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxMSBjb3B5IDI3PC90aXRsZT48ZyBpZD0iUHVyY2hhc2VfUmVxdWlzaXRpb24iIGRhdGEtbmFtZT0iUHVyY2hhc2UgUmVxdWlzaXRpb24iPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM0Ljk1LDM1LjI0YzAtOS40NC00LjY1LTE3LjA5LTEwLjQtMTcuMDlzLTEwLjQsNy42NS0xMC40LDE3LjA5aDBhMjIsMjIsMCwwLDAsMjAuNzksMFoiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMiIgY3g9IjI0LjU1IiBjeT0iMTIuODIiIHI9IjcuNDYiLz48cG9seWxpbmUgY2xhc3M9ImNscy0yIiBwb2ludHM9IjQwLjEgMzAuOTYgNDAuMSA0Mi45MiAyNy40MyA0Mi45MiAyNy40MyAyNi4zIDM1LjY5IDI2LjMiLz48cG9seWxpbmUgY2xhc3M9ImNscy0yIiBwb2ludHM9IjM1LjY5IDI2LjMgMzUuNjkgMzAuOTYgNDAuMSAzMC45NiIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/purchase-requisition.9c0039bd.png";

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMSwuY2xzLTJ7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5SZWZlcnJhbCBQcm9ncmFtPC90aXRsZT48ZyBpZD0iUmVmZXJyYWwuc3ZnIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xOS4zMiwzMi4yMWMwLTYuNjYtMy4yOC0xMi4wNi03LjM0LTEyLjA2cy03LjM0LDUuNC03LjM0LDEyLjA2aDBhMTUuNDksMTUuNDksMCwwLDAsMTQuNjcsMFoiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMiIgY3g9IjExLjk5IiBjeT0iMTYuMzkiIHI9IjUuMjYiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00NS45MywzMi4yMWMwLTYuNjYtMy4yOC0xMi4wNi03LjM0LTEyLjA2cy03LjM0LDUuNC03LjM0LDEyLjA2aDBhMTUuNDksMTUuNDksMCwwLDAsMTQuNjcsMFoiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMiIgY3g9IjM4LjYiIGN5PSIxNi4zOSIgcj0iNS4yNiIvPjxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMjAuOTYgMjAuOTUgMjkuNjYgMjAuOTUgMjUuNzIgMTcuMDIiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSIyNS4zMSIgeTE9IjI0Ljk4IiB4Mj0iMjkuNjYiIHkyPSIyMC45NSIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODciIGhlaWdodD0iMTg3IiB2aWV3Qm94PSIwIDAgMTg3IDE4NyI+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIzNi41ODIlIiB4Mj0iNjguODM3JSIgeTE9IjY4Ljc4MyUiIHkyPSIyMy42MjYlIj4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzIyMTU1NiIvPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjIwJSIgc3RvcC1jb2xvcj0iIzIyMUE2MiIvPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiMyMTJGOTMiLz4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iYiIgeDE9IjQ5Ljk2MSUiIHgyPSI0OS45NjElIiB5MT0iMjUuNDM2JSIgeTI9Ijc2LjU3MyUiPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjRkZGIiBzdG9wLW9wYWNpdHk9IjAiLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjMjEyRjkzIi8+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjE4Ni4wMiIgaGVpZ2h0PSIxODYuMDIiIHg9Ii43NiIgeT0iLjczIiBmaWxsPSJ1cmwoI2EpIiByeD0iNDcuOTUiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTMxLjk5IDExNy42OWgtMTUuMTZWNzYuNzhjMC0xMi43NDEtMTAuMzI5LTIzLjA3LTIzLjA3LTIzLjA3UzcwLjY5IDY0LjAzOSA3MC42OSA3Ni43OHY0MC45MUg1NS41NlY3Ni43OGMwLTIxLjExNCAxNy4xMTYtMzguMjMgMzguMjMtMzguMjMgMjEuMTE0IDAgMzguMjMgMTcuMTE2IDM4LjIzIDM4LjIzbC0uMDMgNDAuOTF6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0idXJsKCNiKSIgZD0iTTEzMS45OSAxMTcuNjloLTE1LjE2Vjc2Ljc4YzAtMTIuNzQxLTEwLjMyOS0yMy4wNy0yMy4wNy0yMy4wN1M3MC42OSA2NC4wMzkgNzAuNjkgNzYuNzh2NDAuOTFINTUuNTZWNzYuNzhjMC0yMS4xMTQgMTcuMTE2LTM4LjIzIDM4LjIzLTM4LjIzIDIxLjExNCAwIDM4LjIzIDE3LjExNiAzOC4yMyAzOC4yM2wtLjAzIDQwLjkxeiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xMTcuMDkgODIuMTRINzAuMzhjLTguMTg4LjAxMS0xNC44MiA2LjY1Mi0xNC44MiAxNC44NHYzNi43MmExNC44NCAxNC44NCAwIDAgMCAxNC44NCAxNC44NGg0Ni43MmExNC44NCAxNC44NCAwIDAgMCAxNC44NC0xNC44NFY5Ni45OGExNC44NCAxNC44NCAwIDAgMC0xNC44Ny0xNC44NHptLTE5LjcxIDM3LjM1djE0LjQ2aC04di0xNC40N2E3LjI1IDcuMjUgMCAxIDEgOCAwdi4wMXoiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/services.187ecdb4.png";

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/social.65cee3d6.png";

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMSwuY2xzLTJ7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5TdXJ2ZXkgRmVlZGJhY2s8L3RpdGxlPjxnIGlkPSJGZWVkYmFjay5zdmciPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTMyLjkzLDMxLjE4SDI2LjQ4QTIxLjU2LDIxLjU2LDAsMCwwLDguMTYsNDEuMzlsLS40NS43M3YtMjFhNy44Nyw3Ljg3LDAsMCwxLDcuODctNy44N0gzMi45M2E5LDksMCwwLDEsOSw5aDBBOSw5LDAsMCwxLDMyLjkzLDMxLjE4WiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIyNy45MyAyMS4wNyAzMS4zIDI3LjkgMzguODMgMjkgMzMuMzggMzQuMzEgMzQuNjcgNDEuODEgMjcuOTMgMzguMjcgMjEuMTkgNDEuODEgMjIuNDggMzQuMzEgMTcuMDMgMjkgMjQuNTYgMjcuOSAyNy45MyAyMS4wNyIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/survey.263ec41b.png";

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMSwuY2xzLTJ7c3Ryb2tlOiMyZTcxZjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5IdWJibGVyIFNvY2lhbDwvdGl0bGU+PGcgaWQ9IlNvY2lhbC5zdmciPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI1LjE2LDMzLjczYzAtNy4yNS0zLjU4LTEzLjE0LTgtMTMuMTRzLTgsNS44OC04LDEzLjE0aDBhMTYuODcsMTYuODcsMCwwLDAsMTYsMFoiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMiIgY3g9IjE3LjE3IiBjeT0iMTYuNDkiIHI9IjUuNzMiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00MS4xNSwzMy43M2MwLTcuMjUtMy41OC0xMy4xNC04LTEzLjE0cy04LDUuODgtOCwxMy4xNGgwYTE2Ljg3LDE2Ljg3LDAsMCwwLDE2LDBaIi8+PGNpcmNsZSBjbGFzcz0iY2xzLTIiIGN4PSIzMy4xNSIgY3k9IjE2LjQ5IiByPSI1LjczIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMzMuMTUsMzkuNzJjMC03LjI1LTMuNTgtMTMuMTQtOC0xMy4xNHMtOCw1Ljg4LTgsMTMuMTRoMGExNi44NywxNi44NywwLDAsMCwxNiwwWiIvPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iMjUuMTYiIGN5PSIyMi40OCIgcj0iNS43MyIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vendor-management.981967c4.png";

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4NCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgODQgNSI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI0Ij4KICAgICAgICA8cGF0aCBzdHJva2U9IiMwMDVFRkYiIGQ9Ik0yIDIuNWg3MCIvPgogICAgICAgIDxwYXRoIHN0cm9rZT0iI0ZEMzc3RSIgZD0iTTgxLjUgMi41aC41Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NSIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgNzUgNSI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI0Ij4KICAgICAgICA8cGF0aCBzdHJva2U9IiNGRDM3N0UiIGQ9Ik0yLjUgMi41SDU0Ii8+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjMDA1RUZGIiBkPSJNNjMuNSAyLjVoLjUiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiNGRkM0MDAiIGQ9Ik03Mi41IDIuNWguNSIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/group-copy-2.3beb3829.png";

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hubbler-studio-1.03978176.png";

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info1.96b55b80.png";

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info10.1fb1261f.png";

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info11.f73369ae.png";

/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info12.77a59e7a.png";

/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info13.a164a12d.png";

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info14.84e885b4.png";

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info2.76852ce4.png";

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info3.1cb9f911.png";

/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info4.ba53d08a.png";

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info5.8bc4e577.png";

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info6.ea542a97.png";

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info7.ab86ae20.png";

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info8.919dd0cf.png";

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info9.d8232033.png";

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/card-15@2x.9caf3ce0.png";

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/claims-copy@2x.be8f72e9.png";

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/claims@2x.9895a6a9.png";

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/group-3-copy-2.246e0358.png";

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/group-3@2x.04c06af0.png";

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/info1.96b55b80.png";

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mobile-phone1.9169e7a8.png";

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mobile-phone2.438cb6ec.png";

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mobile-phone3.7eca997b.png";

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mobile-phone4.7d088720.png";

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mobile-phone5.f848380c.png";

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mobile-phone6.fb1b7229.png";

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slide-02@2x.3aabf4b8.png";

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tasks@2x.5ad94bd9.png";

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/phone@2x.75b1e60e.png";

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/qus-bg-01.55a86ff0.png";

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/qus-bg-02.f463dd64.png";

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/qus-bg-03.0e3b853d.png";

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/qus-bg-04.c77179f6.png";

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/qus-bg-05.9108afb4.png";

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/qus-bg-06.3563caac.png";

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/golive-34po.259131fb.png";

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/group-2.3159886d.png";

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/intergrate@2x.c1252e5e.png";

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/problems@2x.66f2e585.png";

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LogoSliderComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _aos = __webpack_require__(30);
	
	var _aos2 = _interopRequireDefault(_aos);
	
	var _SideScroll = __webpack_require__(70);
	
	var _ShowApps = __webpack_require__(69);
	
	var _Solutions = __webpack_require__(71);
	
	var _Solutions2 = _interopRequireDefault(_Solutions);
	
	var _ContentSilder = __webpack_require__(67);
	
	var _ContentSilder2 = _interopRequireDefault(_ContentSilder);
	
	var _HubblerStudio = __webpack_require__(68);
	
	var _HubblerStudio2 = _interopRequireDefault(_HubblerStudio);
	
	var _Footer = __webpack_require__(37);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _groupCopy = __webpack_require__(153);
	
	var _groupCopy2 = _interopRequireDefault(_groupCopy);
	
	var _webData = __webpack_require__(18);
	
	var _reactCountup = __webpack_require__(83);
	
	var _reactCountup2 = _interopRequireDefault(_reactCountup);
	
	var _dividerLine = __webpack_require__(151);
	
	var _dividerLine2 = _interopRequireDefault(_dividerLine);
	
	var _group76Copy = __webpack_require__(152);
	
	var _group76Copy2 = _interopRequireDefault(_group76Copy);
	
	var _reactAliceCarousel = __webpack_require__(12);
	
	var _reactAliceCarousel2 = _interopRequireDefault(_reactAliceCarousel);
	
	var _Typing = __webpack_require__(72);
	
	var _Typing2 = _interopRequireDefault(_Typing);
	
	var _CompanyLogos = __webpack_require__(36);
	
	var _CompanyLogos2 = _interopRequireDefault(_CompanyLogos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var responsive = {
	    0: {
	        items: 2
	    },
	    320: {
	        items: 2
	    },
	    550: {
	        items: 3
	    },
	    768: {
	        items: 4
	    },
	    1024: {
	        items: 4
	    },
	    1260: {
	        items: 5
	    },
	    1460: {
	        items: 5
	    },
	    3000: {
	        items: 5
	    }
	};
	
	var LogoSliderComponent = exports.LogoSliderComponent = function (_React$Component) {
	    _inherits(LogoSliderComponent, _React$Component);
	
	    function LogoSliderComponent() {
	        _classCallCheck(this, LogoSliderComponent);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    LogoSliderComponent.prototype.galleryItems = function galleryItems() {
	        return _CompanyLogos.imageList.map(function (item) {
	            return _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement('img', { src: item })
	            );
	        });
	    };
	
	    LogoSliderComponent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'company-logos' },
	            _react2.default.createElement(_reactAliceCarousel2.default, { autoPlay: true, autoPlayInterval: 2500, duration: 400, responsive: responsive, items: this.galleryItems() })
	        );
	    };
	
	    return LogoSliderComponent;
	}(_react2.default.Component);
	
	var IndexPage = function (_React$Component2) {
	    _inherits(IndexPage, _React$Component2);
	
	    function IndexPage() {
	        _classCallCheck(this, IndexPage);
	
	        var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this));
	
	        _this2.state = {
	            previewItem: 2,
	            countAnimation: true,
	            width: '',
	            height: ''
	        };
	        return _this2;
	    }
	
	    IndexPage.prototype.componentDidMount = function componentDidMount() {
	        var _this3 = this;
	
	        var self = this;
	        this.aos = _aos2.default;
	        this.aos.init({
	            duration: 1500,
	            once: true
	        });
	        window.addEventListener('scroll', function (event) {
	            if (document.getElementById('hubber-count')) {
	                var elementOffset = document.getElementById('hubber-count').offsetTop;
	                var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
	                if (_this3.state.countAnimation) {
	                    if (elementOffset < scrollPosition + 600) {
	                        (0, _reactCountup.startAnimation)(self.myCountUp);
	                        (0, _reactCountup.startAnimation)(self.customApps);
	                        (0, _reactCountup.startAnimation)(self.usersOnboard);
	                        self.setState({
	                            countAnimation: false
	                        });
	                    }
	                }
	            }
	        });
	    };
	
	    IndexPage.prototype.componentDidUpdate = function componentDidUpdate() {
	        this.aos.refresh();
	    };
	
	    IndexPage.prototype.previewItemsDetails = function previewItemsDetails(id) {
	        this.setState({
	            previewItem: id
	        });
	    };
	
	    IndexPage.prototype.galleryItems = function galleryItems() {
	        return _CompanyLogos.imageList.map(function (item) {
	            return _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement('img', { src: item })
	            );
	        });
	    };
	
	    IndexPage.prototype.render = function render() {
	        var _this4 = this;
	
	        var previewDetails = _webData.data.find(function (item) {
	            return item.id == _this4.state.previewItem;
	        });
	        return _react2.default.createElement(
	            'div',
	            { className: 'products' },
	            _react2.default.createElement(
	                'div',
	                { className: 'start-mobile' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'start-content', id: 'product' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'platform' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'platform-sub' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'head-info', 'data-aos': 'fade-up' },
	                                'Turn your idea into an app',
	                                _react2.default.createElement('br', null),
	                                'in record time'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { 'data-aos': 'fade-up' },
	                                'Hubbler\u2019s no-code, DIY platform lets enterprises build powerful apps to automate their unique business processes. Build on iOS, Android and Web simultaneously and give your team software that fits like a glove.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'socail-media' },
	                            _react2.default.createElement('a', { className: 'apple', href: 'https://itunes.apple.com/in/app/hubbler/id1190887110?mt=8', target: '_blank' }),
	                            _react2.default.createElement('a', { className: 'google', href: 'https://play.google.com/store/apps/details?id=mobi.hubbler.app', target: '_blank' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(LogoSliderComponent, null),
	            _react2.default.createElement(
	                'div',
	                { className: 'find-apps-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'solutions-container', id: 'marketPlace' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'solutions-details' },
	                        _react2.default.createElement(_Solutions2.default, null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'find-apps-text', 'data-aos': 'fade-up' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text' },
	                        'Or choose from our fully customisable, ready-to-use apps'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Pick and choose apps that suit your team\u2019s workflows. Modify them as per your team\u2019s needs. Onboard your team and start working in record time.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'find-apps-list-container' },
	                    _react2.default.createElement(_ShowApps.ShowApps, { appsData: _webData.appsData })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'enhance-your-productivity' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'enhance-your-productivity-sub' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'style-img' },
	                            _react2.default.createElement('div', { className: 'style-img-sub', 'data-aos': 'fade-up' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'discription' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title', 'data-aos': 'fade-up' },
	                                'Stop using software that was built for someone else'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'parp', 'data-aos': 'fade-up' },
	                                'Customize everything about your app from start to finish. Give your team an application that\u2019s perfect for their business process. No more compromises, adjustments and workarounds. Get software that\u2019s perfect for the job and easy to use.'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'solutions-together-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'solutions-together-details' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'preview-img web' },
	                            _react2.default.createElement('div', { className: 'show-img', 'data-aos': 'zoom-in' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'details' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'title', 'data-aos': 'fade-up' },
	                                'Integrate, Automate & Accelerate'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'preview-img mobile' },
	                                _react2.default.createElement('div', { className: 'show-img', 'data-aos': 'zoom-in' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { 'data-aos': 'fade-up' },
	                                'We get it: you can\'t stop using your legacy systems. They hold all your business data. We\u2019re talking about your ERP, CRM, accounting systems, and other legacy applications. Good news! Hubbler can integrate with all of them seamlessly. And automate a variety of manual, repetitive tasks within them, allowing you to speed up process cycles and register incredible cost savings.'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'what-unique', 'data-aos': 'fade-up' },
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    'What makes us unique'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'what-unique-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'what-unique-container-sub' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'unique-cls plug-and-play', 'data-aos': 'zoom-in-up' },
	                        _react2.default.createElement('div', { className: 'logo' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'dis' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'head' },
	                                'Plug and play'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                '200+ apps to choose from.  As and when you need them'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'unique-cls  no-code', 'data-aos': 'zoom-in-up' },
	                        _react2.default.createElement('div', { className: 'logo' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'dis' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'head' },
	                                'No Code, All DIY'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Digitise any process as you go'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'unique-cls  anytime-anywhere', 'data-aos': 'zoom-in-up' },
	                        _react2.default.createElement('div', { className: 'logo' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'dis' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'head' },
	                                'Anytime Anywhere'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Web, Mobile, Online, Offline, Everything Covered!'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'unique-cls  compatible', 'data-aos': 'zoom-in-up' },
	                        _react2.default.createElement('div', { className: 'logo' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'dis' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'head' },
	                                'Compatible'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Integrates seamlessly with ERPs, Payment Gateways, Legacy Systems, etc'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'content-slider-container' },
	                _react2.default.createElement(_ContentSilder2.default, null)
	            ),
	            _react2.default.createElement('div', null)
	        );
	    };
	
	    return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _miniPortal_components = __webpack_require__(206);
	
	var _mini_portal = __webpack_require__(207);
	
	var _mini_portal2 = _interopRequireDefault(_mini_portal);
	
	var _List = __webpack_require__(11);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _communityEngagement = __webpack_require__(400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var landingPageContent = { head: 'Your community at your fingertips', para: 'Hubbler Connect delivers on its name. We help people connect, collaborate, engage and share within a community by providing all resources and communication enablers in one place.' };
	
	var headerMobileView = { head: 'Member Connect', para: 'Be Inspired - Interact & Collaborate. Post photos, videos - Share special moments with your network. Bring camaraderie among members with various opportunities & topics for intriguing discussions. This makes the conversations genuine, relevant & brings back active & inactive members.' };
	
	var Connect = function (_MiniProtal) {
	    _inherits(Connect, _MiniProtal);
	
	    function Connect() {
	        _classCallCheck(this, Connect);
	
	        return _possibleConstructorReturn(this, _MiniProtal.apply(this, arguments));
	    }
	
	    Connect.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'mini-protal-component' },
	            _react2.default.createElement(_miniPortal_components.LandingPage, { content: landingPageContent }),
	            _react2.default.createElement(_miniPortal_components.MobileViewComponent, { communityWebViewData: _communityEngagement.communityWebViewData, communityMobileViewData: _communityEngagement.communityMobileViewData, headerData: headerMobileView }),
	            _react2.default.createElement(
	                'div',
	                { className: 'first-list-view' },
	                _react2.default.createElement(_List2.default, { listItem: _miniPortal_components.InfoItemView, items: _communityEngagement.infoList1, className: 'info-list-view' })
	            ),
	            _react2.default.createElement(_miniPortal_components.DashbordCarousel, { dashboardData: _communityEngagement.dashboardData, dashboardDataMobile: _communityEngagement.dashboardDataMobile }),
	            _react2.default.createElement(
	                'div',
	                { className: 'secand-list-view' },
	                _react2.default.createElement(_List2.default, { listItem: _miniPortal_components.InfoItemView, items: _communityEngagement.infoList2, className: 'info-list-view' })
	            ),
	            _react2.default.createElement(_miniPortal_components.RequestDemo, null)
	        );
	    };
	
	    return Connect;
	}(_mini_portal2.default);
	
	exports.default = Connect;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-solutions-community-engagement-js-ac085007c3b967161997.js